// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"1gxIg":[function(require,module,exports) {
//import { VanillaJSCarousel } from "./carousel";
var _common = require("./common");
var _carousel = require("./carousel");
const gifView = document.getElementById("gifView");
const btnGif = document.getElementById("btnGif");
const carouselView = document.getElementById("carView");
const inGifSearch = document.getElementById("inGifSearch");
const textContainer = document.getElementById("textContainer");
var elGif = document.getElementById("spCl");
var car;
var defaulInput = "Dancing";
var isGiphyLoaded;
//let car : VanillaJSCarousel;
if (carouselView) {
    if (elGif != null) {
        car = new (0, _carousel.VanillaJSCarousel)(carouselView, defaulInput, elGif);
        elGif.addEventListener("click", function() {
            if (car) {
                //console.log("gif: " + car.getUrl());
                var gifLink = "https://media2.giphy.com/media/" + car.getUrl() + "/giphy.gif";
                this.textContent = gifLink;
                inGifSearch.value = "";
                btnGif.style.backgroundImage = "url('" + (0, _common.gphGif) + "')" + ",linear-gradient(to right, rgb(5, 0, 156), rgb(39,199,254))";
                var event = new Event("change");
                // Dispatch it.
                this.dispatchEvent(event);
            //uploadGif(car.getUrl());
            }
        });
    }
}
btnGif.onclick = function() {
    if (gifView.style.display == "none" || !gifView.style.display) {
        (0, _common.setDisplay)(gifView, "flex");
        inGifSearch.focus();
        if (!isGiphyLoaded) loadGifs();
        btnGif.style.backgroundImage = "url('" + (0, _common.gphClose) + "')" + ",linear-gradient(to right, rgb(5, 0, 156), rgb(39,199,254))";
    } else {
        if (textContainer != null) textContainer.focus();
        (0, _common.setDisplay)(gifView, "none");
        btnGif.style.backgroundImage = "url('" + (0, _common.gphGif) + "')" + ",linear-gradient(to right, rgb(5, 0, 156), rgb(39,199,254))";
    }
};
// function setDisplay(element: HTMLElement, displayType: string){
//     // if(element && !element.style){
//     //     element = document.getElementById(element);
//     // }
//     element.style.display = displayType;
// }
function loadGifs() {
    inGifSearch.addEventListener("input", function() {
        var searchValue = inGifSearch.value.trim();
        if (searchValue === "") {
            if (!car && carouselView) {
                if (elGif == null) return;
                car = new (0, _carousel.VanillaJSCarousel)(carouselView, defaulInput, elGif);
            } else car.searchGiphy(defaulInput);
        } else if (!car && carouselView) {
            if (elGif == null) return;
            car = new (0, _carousel.VanillaJSCarousel)(carouselView, searchValue, elGif);
        } else car.searchGiphy(searchValue);
    });
}

},{"./common":"loJev","./carousel":"kixgL"}],"loJev":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initCommonViews", ()=>initCommonViews);
parcelHelpers.export(exports, "checkDevice", ()=>checkDevice);
parcelHelpers.export(exports, "closeModal", ()=>closeModal);
parcelHelpers.export(exports, "closeMyModal", ()=>closeMyModal);
parcelHelpers.export(exports, "openCommonModal", ()=>openCommonModal);
parcelHelpers.export(exports, "setDisplay", ()=>setDisplay);
parcelHelpers.export(exports, "setModalMessage", ()=>setModalMessage);
parcelHelpers.export(exports, "showToast", ()=>showToast);
parcelHelpers.export(exports, "getAudioTime", ()=>getAudioTime);
parcelHelpers.export(exports, "getDuration", ()=>getDuration);
parcelHelpers.export(exports, "sameDay", ()=>sameDay);
parcelHelpers.export(exports, "formatMessageDate", ()=>formatMessageDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "formatMilTime", ()=>formatMilTime);
parcelHelpers.export(exports, "getDayAbbr", ()=>getDayAbbr);
parcelHelpers.export(exports, "sendVoiceMsg", ()=>sendVoiceMsg);
parcelHelpers.export(exports, "sendTextMessage", ()=>sendTextMessage);
parcelHelpers.export(exports, "sendGifMessage", ()=>sendGifMessage);
parcelHelpers.export(exports, "disableButton", ()=>disableButton);
parcelHelpers.export(exports, "setBackgroundImage", ()=>setBackgroundImage);
parcelHelpers.export(exports, "addSizeToGoogleProfilePic", ()=>addSizeToGoogleProfilePic);
parcelHelpers.export(exports, "linkify", ()=>linkify);
parcelHelpers.export(exports, "setCookie", ()=>setCookie);
parcelHelpers.export(exports, "deleteCookie", ()=>deleteCookie);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
parcelHelpers.export(exports, "appId", ()=>appId);
parcelHelpers.export(exports, "dragElement", ()=>dragElement);
parcelHelpers.export(exports, "saveLocalFile", ()=>saveLocalFile);
parcelHelpers.export(exports, "saveFile", ()=>saveFile);
parcelHelpers.export(exports, "copyText", ()=>copyText);
parcelHelpers.export(exports, "copyInput", ()=>copyInput);
parcelHelpers.export(exports, "gphClose", ()=>gphClose);
parcelHelpers.export(exports, "gphGif", ()=>gphGif);
parcelHelpers.export(exports, "getGenre", ()=>getGenre);
parcelHelpers.export(exports, "getGenreIndex", ()=>getGenreIndex);
parcelHelpers.export(exports, "getGenreList", ()=>getGenreList);
parcelHelpers.export(exports, "getLangList", ()=>getLangList);
parcelHelpers.export(exports, "getLangCode", ()=>getLangCode);
parcelHelpers.export(exports, "getLangIndex", ()=>getLangIndex);
parcelHelpers.export(exports, "getLangName", ()=>getLangName);
parcelHelpers.export(exports, "getCountryList", ()=>getCountryList);
parcelHelpers.export(exports, "getCountryCode", ()=>getCountryCode);
parcelHelpers.export(exports, "getCountryIndex", ()=>getCountryIndex);
parcelHelpers.export(exports, "getCountryName", ()=>getCountryName);
parcelHelpers.export(exports, "reformatPaste", ()=>reformatPaste);
parcelHelpers.export(exports, "getRandomNum", ()=>getRandomNum);
parcelHelpers.export(exports, "getPodClass", ()=>getPodClass);
parcelHelpers.export(exports, "validateEmail", ()=>validateEmail);
parcelHelpers.export(exports, "validateURL", ()=>validateURL);
parcelHelpers.export(exports, "validateLettersNums", ()=>validateLettersNums);
parcelHelpers.export(exports, "removeTags", ()=>removeTags);
parcelHelpers.export(exports, "parseDuration", ()=>parseDuration);
parcelHelpers.export(exports, "formatTimeHMS", ()=>formatTimeHMS);
parcelHelpers.export(exports, "formatDurationHMS", ()=>formatDurationHMS);
parcelHelpers.export(exports, "DATABASE_IN_APP_PRODUCTS", ()=>DATABASE_IN_APP_PRODUCTS);
parcelHelpers.export(exports, "scrollRight", ()=>scrollRight);
parcelHelpers.export(exports, "scrollLeft", ()=>scrollLeft);
parcelHelpers.export(exports, "scrollTop", ()=>scrollTop);
parcelHelpers.export(exports, "scrollBtm", ()=>scrollBtm);
parcelHelpers.export(exports, "GroupType", ()=>GroupType);
var _gph5Gif = require("url:../images/gph5.gif");
var _gph5GifDefault = parcelHelpers.interopDefault(_gph5Gif);
var _gph1Gif = require("url:../images/gph1.gif");
var _gph1GifDefault = parcelHelpers.interopDefault(_gph1Gif);
var divModal;
var modalMessage;
var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];
var dias = [
    "Domingo",
    "Lunes",
    "Martes",
    "Mi\xe9rcoles",
    "Jueves",
    "Viernes",
    "S\xe1bado"
];
var dayAbbr = [
    "u",
    "m",
    "t",
    "w",
    "r",
    "f",
    "s"
];
var genres = [
    "Arts and culture",
    "Business and economics",
    "Comedy",
    "Education",
    "Fantasy and science fiction",
    "Food and cooking",
    "Health and wellness",
    "History",
    "Kids and family",
    "Language learning",
    "Media and entertainment",
    "Music",
    "News and Politics",
    "Paranormal",
    "Philosophy",
    "Radio drama",
    "Romance",
    "Adult content",
    "Religion and spirituality",
    "Science",
    "Sports and recreation",
    "Storytelling",
    "Talk show replays",
    "Technology",
    "True crime"
];
var generos = [
    "Arte y cultura",
    "Negocios y Econom\xeda",
    "Comedia",
    "Educaci\xf3n",
    "Fantas\xeda y ciencia ficci\xf3n",
    "Comida y cocina",
    "Salud y bienestar",
    "Historial",
    "Ni\xf1os y familia",
    "Aprendizaje de idiomas",
    "Medios y entretenimiento",
    "M\xfasica",
    "Noticias y pol\xedtica",
    "Paranormal",
    "Filosof\xeda",
    "Radio drama",
    "Romance",
    "Contenido para adultos",
    "Religi\xf3n y espiritualidad",
    "Ciencia",
    "Deportes y recreaci\xf3n",
    "Narraci\xf3n de cuentos",
    "Repeticiones de programas de entrevistas",
    "Tecnolog\xeda",
    "Crimen verdadero"
];
var langs = [
    "Afrikaans",
    "Albanian",
    "Arabic",
    "Belarusian",
    "Bulgarian",
    "Bengali",
    "Catalan",
    "Chinese",
    "Croatian",
    "Czech",
    "Danish",
    "Dutch",
    "English",
    "Esperanto",
    "Estonian",
    "Finnish",
    "French",
    "Galician",
    "Georgian",
    "German",
    "Greek",
    "Gujarati",
    "Haitian",
    "Hebrew",
    "Hindi",
    "Hungarian",
    "Icelandic",
    "Indonesian",
    "Irish",
    "Italian",
    "Japanese",
    "Kannada",
    "Korean",
    "Lithiuanian",
    "Latvian",
    "Macedonian",
    "Marathi",
    "Malay",
    "Maltese",
    "Norwegian",
    "Persian",
    "Polish",
    "Portuguese",
    "Romanian",
    "Russian",
    "Slovak",
    "Slovenian",
    "Spanish",
    "Swedish",
    "Swahili",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Thai",
    "Turkish",
    "Ukrainian",
    "Urdu",
    "Vietnamese",
    "Welsh"
];
var lengs = [
    "Africaans",
    "Alban\xe9s",
    "Ar\xe1bica",
    "Bielorruso",
    "B\xfalgaro",
    "Bengal\xed",
    "Catal\xe1n",
    "Chino",
    "Croata",
    "Checo",
    "Dan\xe9s",
    "Holand\xe9s",
    "Ingl\xe9s",
    "Esperanto",
    "Estonio",
    "Finland\xe9s",
    "Franc\xe9s",
    "Gallego",
    "Georgiano",
    "Alem\xe1n",
    "Griego",
    "Gujarati",
    "Haitiano",
    "Hebreo",
    "Hindi",
    "H\xfangaro",
    "Island\xe9s",
    "Indonesio",
    "Irland\xe9s",
    "Italiano",
    "Japon\xe9s",
    "Kannada",
    "Coreano",
    "Lituano",
    "Let\xf3n",
    "Macedonio",
    "Marathi",
    "Malayo",
    "Malt\xe9s",
    "Noruego",
    "Persia",
    "Polaco",
    "Portugu\xe9s",
    "Romano",
    "Ruso",
    "Eslovaco",
    "Esloveno",
    "Espa\xf1ol",
    "Sueco",
    "Swahili",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Tailand\xe9s",
    "Turco",
    "Ucraniano",
    "Urdu",
    "Vietnamita",
    "Gal\xe9s"
];
var langCode = [
    "af",
    "sq",
    "ar",
    "be",
    "bg",
    "bn",
    "ca",
    "zh",
    "hr",
    "cs",
    "da",
    "nl",
    "en",
    "eo",
    "et",
    "fi",
    "fr",
    "gl",
    "ka",
    "de",
    "el",
    "gu",
    "ht",
    "he",
    "hi",
    "hu",
    "is",
    "id",
    "ga",
    "it",
    "ja",
    "kn",
    "ko",
    "lt",
    "lv",
    "mk",
    "mr",
    "ms",
    "mt",
    "no",
    "fa",
    "pl",
    "pt",
    "ro",
    "ru",
    "sk",
    "sl",
    "es",
    "sv",
    "sw",
    "tl",
    "ta",
    "te",
    "th",
    "tr",
    "uk",
    "ur",
    "vi",
    "cy"
];
const paisList = [
    "Afganist\xe1n",
    "Albania",
    "Argelia",
    "Samoa Americana",
    "Andorra",
    "Angola",
    "Anguila",
    "Ant\xe1rtida",
    "Antigua y Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaiy\xe1n",
    "Bahamas",
    "Bahr\xe9in",
    "Bangladesh",
    "Barbados",
    "Bielorrusia",
    "B\xe9lgica",
    "Belice",
    "Benin",
    "Islas Bermudas",
    "But\xe1n",
    "Bolivia (Estado Plurinacional de)",
    "Bonaire, Sint Eustatius y Saba",
    "Bosnia y Herzegovina",
    "Botswana",
    "Isla Bouvet",
    "Brasil",
    "Territorio Brit\xe1nico del Oc\xe9ano \xcdndico",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Camboya",
    "Camer\xfan",
    "Canad\xe1",
    "Islas Caim\xe1n",
    "Rep\xfablica Centroafricana",
    "Chad",
    "Chile",
    "Porcelana",
    "Isla de Navidad",
    "Islas Cocos (Keeling)",
    "Colombia",
    "Comoras",
    "Congo (Rep\xfablica Democr\xe1tica del)",
    "Congo",
    "Islas Cook",
    "Costa Rica",
    "Croacia",
    "Cuba",
    "Curazao",
    "Chipre",
    "Chequia",
    "C\xf4te d'Ivoire",
    "Dinamarca",
    "Djibouti",
    "Dominica",
    "Rep\xfablica Dominicana",
    "Ecuador",
    "Egipto",
    "El Salvador",
    "Guinea Ecuatorial",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Etiop\xeda",
    "Islas Falkland [Malvinas]",
    "Islas Faroe",
    "Fiji",
    "Finlandia",
    "Francia",
    "Guayana Francesa",
    "Polinesia franc\xe9s",
    "Territorios Franceses del Sur",
    "Gab\xf3n",
    "Gambia",
    "Georgia",
    "Alemania",
    "Ghana",
    "Gibraltar",
    "Grecia",
    "Groenlandia",
    "Granada",
    "Guadalupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guayana",
    "Hait\xed",
    "Islas Heard y McDonald",
    "Santa Sede",
    "Honduras",
    "Hong Kong",
    "Hungr\xeda",
    "Islandia",
    "India",
    "Indonesia",
    "Ir\xe1n (Rep\xfablica Isl\xe1mica de)",
    "Irak",
    "Irlanda",
    "Isla del hombre",
    "Israel",
    "Italia",
    "Jamaica",
    "Jap\xf3n",
    "Su\xe9ter",
    "Jord\xe1n",
    "Kazajst\xe1n",
    "Kenia",
    "Kiribati",
    "Corea (Rep\xfablica Popular Democr\xe1tica de)",
    "Corea (Rep\xfablica de)",
    "Kuwait",
    "Kirguist\xe1n",
    "Rep\xfablica Democr\xe1tica Popular Lao",
    "Letonia",
    "L\xedbano",
    "Lesoto",
    "Liberia",
    "Libia",
    "Liechtenstein",
    "Lituania",
    "Luxemburgo",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malasia",
    "Maldivas",
    "Mal\xed",
    "Malta",
    "Islas Marshall",
    "Martinica",
    "Mauritania",
    "Mauricio",
    "Mayotte",
    "M\xe9xico",
    "Micronesia (Estados Federados de)",
    "Moldova (la Rep\xfablica de)",
    "M\xf3naco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Marruecos",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Pa\xedses Bajos",
    "Nueva Caledonia",
    "Nueva Zelanda",
    "Nicaragua",
    "N\xedger",
    "Nigeria",
    "Niue",
    "Isla Norfolk",
    "Islas Marianas del Norte",
    "Noruega",
    "Om\xe1n",
    "Pakist\xe1n",
    "Palau",
    "Palestina, Estado de",
    "Panam\xe1",
    "Pap\xfaa Nueva Guinea",
    "Paraguay",
    "Per\xfa",
    "Filipinas",
    "Pitcairn",
    "Polonia",
    "Portugal",
    "Puerto Rico",
    "Katar",
    "Rep\xfablica de Macedonia del Norte",
    "Rumania",
    "Federaci\xf3n Rusa",
    "Ruanda",
    "Cita",
    "San Bartolom\xe9",
    "Santa Elena, Ascensi\xf3n y Tristan da Cunha",
    "Saint Kitts y Nevis",
    "Santa Luc\xeda",
    "San Mart\xedn (parte francesa)",
    "San Pedro y Miquel\xf3n",
    "San Vicente y las Granadinas",
    "Samoa",
    "San Marino",
    "Santo Tom\xe9 y Pr\xedncipe",
    "Arabia Saudita",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leona",
    "Singapur",
    "Sint Maarten (parte holandesa)",
    "Eslovaquia",
    "Eslovenia",
    "Islas Salom\xf3n",
    "Somalia",
    "Sud\xe1frica",
    "Georgia del sur y las islas Sandwich del sur",
    "Sud\xe1n del Sur",
    "Espa\xf1a",
    "Sri Lanka",
    "Sud\xe1n",
    "Surinam",
    "Svalbard y Jan Mayen",
    "Suecia",
    "Suiza",
    "Rep\xfablica \xc1rabe Siria",
    "Taiw\xe1n",
    "Tayikist\xe1n",
    "Rep\xfablica Unida de Tanzan\xeda",
    "Tailandia",
    "Timor-Leste",
    "Ir",
    "Tokelau",
    "Tonga",
    "Trinidad y Tobago",
    "T\xfanez",
    "Pavo",
    "Turkmenist\xe1n",
    "Islas Turcas y Caicos",
    "Tuvalu",
    "Uganda",
    "Ucrania",
    "Emiratos \xc1rabes Unidos",
    "Reino Unido de Gran Breta\xf1a e Irlanda del Norte",
    "Islas menores alejadas de los Estados Unidos",
    "Estados Unidos",
    "Uruguay",
    "Uzbekist\xe1n",
    "Vanuatu",
    "Venezuela (Rep\xfablica Bolivariana de)",
    "Vietnam",
    "Islas V\xedrgenes (Brit\xe1nicas)",
    "Islas V\xedrgenes (EE. UU.)",
    "Wallis y Futuna",
    "Sahara Occidental",
    "Yemen",
    "Zambia",
    "Zimbabue",
    "Islas Aland"
];
const countryList = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia (Plurinational State of)",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo (the Democratic Republic of the)",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cura\xe7ao",
    "Cyprus",
    "Czechia",
    "C\xf4te d'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Falkland Islands [Malvinas]",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran (Islamic Republic of)",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea (the Democratic People's Republic of)",
    "Korea (the Republic of)",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia (Federated States of)",
    "Moldova (the Republic of)",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine, State of",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of North Macedonia",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "R\xe9union",
    "Saint Barth\xe9lemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom of Great Britain and Northern Ireland",
    "United States Minor Outlying Islands",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela (Bolivarian Republic of)",
    "Viet Nam",
    "Virgin Islands (British)",
    "Virgin Islands (U.S.)",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "\xc5land Islands"
];
const countryCodeList = [
    "AF",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "CV",
    "KH",
    "CM",
    "CA",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CD",
    "CG",
    "CK",
    "CR",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "CI",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "SZ",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "MK",
    "RO",
    "RU",
    "RW",
    "RE",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "UM",
    "US",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW",
    "AX"
];
var podClass = {
    email: null,
    pod_email: null,
    title: null,
    lcTitle: null,
    host: null,
    uid: null,
    pid: null,
    desc: null,
    feed: null,
    web: null,
    phone: null,
    lang: null,
    country: null,
    genre: null,
    fb: null,
    tw: null,
    ig: null,
    tk: null,
    yt: null,
    wa: null,
    msgWelcome: null,
    icon: null,
    likes: null,
    date: null,
    revenue: null,
    screenBlock: null,
    verified: null,
    donation: null,
    url: null
};
function initCommonViews() {
    divModal = document.getElementById("myModal");
    modalMessage = document.getElementById("modalMessage");
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target == this.divModal) this.closeMyModal(divModal);
    };
}
function checkDevice() {
    var isAndroid = /(android)/i.test(navigator.userAgent);
    if (isAndroid) setDisplay(downloadApp, "flex");
}
function closeModal(modalId) {
    if (!modalId.style) modalId = document.getElementById(modalId);
    modalId.style.display = "none";
}
function closeMyModal() {
    divModal.style.display = "none";
}
function openCommonModal() {
    //closeNav();
    divModal.style.display = "flex";
}
function setDisplay(element, displayType) {
    if (!element.style) element = document.getElementById(element);
    element.style.display = displayType;
}
function setModalMessage(message) {
    if (message != undefined) modalMessage.innerHTML = message;
}
function showToast(message, elmnt, duration) {
    var x = document.getElementById(elmnt ? elmnt : "snackbar");
    if (x == null) {
        x = document.getElementById("toast");
        if (x == null) return;
    }
    x.textContent = message;
    x.className = "show";
    setTimeout(function() {
        x.className = x.className.replace("show", "");
    }, duration ? duration : 3000);
}
function getAudioTime(millis) {
    let sec1 = Math.floor(millis / 1000);
    let hrs = Math.floor(sec1 / 3600);
    sec1 -= hrs * 3600;
    let min1 = Math.floor(sec1 / 60);
    sec1 -= min1 * 60;
    sec1 = "" + sec1;
    sec1 = ("00" + sec1).substring(sec1.length);
    if (hrs > 0) {
        min1 = "" + min1;
        min1 = ("00" + min1).substring(min1.length);
        return hrs + ":" + min1 + ":" + sec1;
    } else return min1 + ":" + sec1;
}
function getDuration(seconds) {
    sec = Math.floor(seconds);
    min = Math.floor(sec / 60);
    min = min >= 10 ? min : "0" + min; //if min >10 don't add 0 infront
    sec = Math.floor(sec % 60);
    sec = sec >= 10 ? sec : "0" + sec;
    return min + ":" + sec;
}
function sameDay(d1, d2) {
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
function formatMessageDate(date, lang) {
    var messageDate;
    const today = new Date();
    const oneDay = 86400000;
    const yesterday = today - oneDay;
    var month;
    if (lang != null && lang === "es") month = meses[date.getMonth()];
    else month = months[date.getMonth()];
    var day = date.getDate();
    var year = date.getFullYear();
    if (sameDay(today, new Date(date))) messageDate = "Today";
    else if (date >= yesterday && date < today) messageDate = "Yesterday";
    else messageDate = month + " " + day + ", " + year;
    return messageDate;
}
function formatTime(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? " PM" : " AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + ampm;
}
function formatMilTime(date, end) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? " PM" : " AM";
    if (end && ampm == " AM" && hours == 0) hours = "24";
    else if (hours == 0) hours = "00";
    if (minutes < 10) minutes = "0" + minutes;
    // if (selStartAmPm.value == "am") {
    //     mH = hr == 12? "00":hrs;
    // }
    return hours + ":" + minutes + " " + ampm;
}
function getDayAbbr(index) {
    if (index < 0 || index >= dayAbbr.length) index = 0;
    return dayAbbr[index];
}
function sendVoiceMsg(url, bmRef, chatRef, rMessage, rKey, chatType, userInfo, chatInfo, chatKey, position, groupList, audDuration) {
    var time = new Date().getTime();
    var messageKey = chatRef.push().key;
    var message = {
        userId: userInfo.userId,
        userName: userInfo.name,
        type: "Audio",
        isUploaded: true,
        audioFile: null,
        phoneFilePath: "web",
        filePath: "web",
        receiverName: chatInfo.name,
        message_key: null,
        receiverId: chatKey,
        audioLength: audDuration,
        isReply: false,
        rePosition: null,
        reSenderName: null,
        reSenderId: null,
        reType: null,
        reMessageKey: null,
        reText: null,
        reFileUrl: null,
        reMediaLength: null,
        messageTime: time,
        web: true
    };
    //
    if (rKey) {
        message.isReply = true;
        message.rePosition = position;
        message.reSenderId = rMessage.userId;
        message.reSenderName = rMessage.userName;
        message.reType = rMessage.type;
        message.reMessageKey = rKey;
        switch(rMessage.type){
            case "Text":
            case "SongRequest":
                message.reText = rMessage.textMessage;
                break;
            case "Audio":
                message.reMediaLength = getAudioTime(rMessage.audioLength);
                break;
            case "Picture":
            case "Gif":
                message.reFileUrl = rMessage.filePath;
                break;
            case "TextPicture":
            case "TextGif":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.filePath;
                break;
            case "Video":
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
            case "TextVideo":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
        }
    }
    var bookmark = {
        type: chatType,
        name: chatInfo.name ? chatInfo.name : null,
        id: chatKey,
        imageUrl: null,
        messageType: "Audio",
        unread_messages: 0,
        email: null,
        date: time,
        radioStream: null,
        creatorId: null,
        lowCaseName: null,
        audioDuration: audDuration
    };
    var audioStRef, friendBmRef, friendChatRef, friendBm, groupBmRef, groupChatRef;
    switch(chatType){
        case "RadioChat":
            audioStRef = firebase.storage().ref().child(`Radio Stations/${chatKey}/Audios/${messageKey}`);
            if (chatInfo.radio_Stream) {
                message.receiverName = chatInfo.radio_Name;
                bookmark.radioStream = chatInfo.radio_Stream;
                bookmark.name = chatInfo.radio_Name;
                bookmark.lowCaseName = chatInfo.radio_Name.toLowerCase();
                if (chatInfo.radio_image) bookmark.imageUrl = chatInfo.radio_image;
            } else {
                bookmark.radioStream = chatInfo.radioStream;
                if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            }
            break;
        case "privateChat":
            audioStRef = firebase.storage().ref().child(`Users/${userInfo.userId}/${chatKey}/Audios/${messageKey}`);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            friendChatRef = firebase.database().ref("PrivateChat/" + chatKey + "/" + userInfo.userId + "/" + messageKey);
            friendBm = {
                type: chatType,
                name: userInfo.name,
                id: userInfo.userId,
                imageUrl: userInfo.profileImage,
                messageType: "Audio",
                unread_messages: 0,
                email: userInfo.email,
                date: time,
                radioStream: null,
                creatorId: null,
                lowCaseName: userInfo.name.toLowerCase(),
                audioDuration: audDuration
            };
            if (chatInfo.profile_Image) bookmark.imageUrl = chatInfo.profile_Image;
            else if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            if (chatInfo.email) bookmark.email = chatInfo.email;
            friendBmRef = firebase.database().ref("Users/" + chatKey + "/Chat_Bookmarks/" + userInfo.userId);
            break;
        case "GroupChat":
            audioStRef = firebase.storage().ref().child(`GroupChats/${chatKey}/Audios/${messageKey}`);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            bookmark.email = chatInfo.email;
            if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            bookmark.creatorId = chatInfo.creatorId;
            groupChatRef = firebase.database().ref("GroupChats/" + chatKey + "/chat");
            groupBmRef = firebase.database().ref("Users");
            break;
        case "podChat":
            audioStRef = firebase.storage().ref().child(`podcast/${chatKey}/Audios/${messageKey}`);
            bookmark.name = chatInfo.title ? chatInfo.title : chatInfo.name;
            bookmark.lowCaseName = bookmark.name.toLowerCase();
            bookmark.radioStream = chatInfo.feed;
            bookmark.imageUrl = chatInfo.icon;
            break;
    }
    //upload audio
    var uploadTask = audioStRef.put(url);
    uploadTask.on("state_changed", function(snapshot) {}, function(error) {
        switch(error.code){
            case "storage/unauthorized":
                // User doesn't have permission to access the object
                //showToast(trans.errorStoragePermission);
                console.log("storage/unauthorized");
                break;
            case "storage/canceled":
                //showToast(trans.errorUploadCanceled);
                console.log("storage/canceled");
                break;
            case "storage/unknown":
                // Unknown error occurred, inspect error.serverResponse
                //showToast(trans.errorRegister);
                console.log("storage/unknown");
                break;
        }
    //setDisplay(loader, "none");
    //disableButton(btnRegister, false);
    }, function() {
        // Handle successful uploads on complete
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            message.audioFile = downloadURL;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                console.log(`Error sending message: ${error} Try again later.`);
                else //message sent
                bmRef.set(bookmark, function(error) {
                    if (error) console.log(`bmRef could not be set: ${error}`);
                    else {
                        if (friendChatRef != null) friendChatRef.set(message, function(error) {
                            if (error) //message failed
                            console.log("Error sending friend message. Try again later.");
                            else //message sent
                            chatRef.child(messageKey).child("sent").set(true, function(error) {
                                if (error) console.log(`Could not set set to true: ${error}`);
                                else friendBmRef.set(friendBm);
                            });
                        });
                        else if (groupChatRef != null) for (let participant of groupList)groupChatRef.child(participant).child(messageKey).set(message, function(error) {
                            if (error) //request failed
                            console.log(`Error sending message to group. Try again later.`);
                            else //request sent
                            groupBmRef.child(participant).child("Chat_Bookmarks").child(chatKey).set(bookmark);
                        });
                    }
                });
            });
        });
    });
}
function sendTextMessage(input1, bmRef, chatRef, rMessage, rKey, chatType, userInfo, chatInfo, chatKey, position, groupList) {
    var time = new Date().getTime();
    var message;
    var messageKey = chatRef.push().key;
    var bookmark;
    message = {
        textMessage: input1,
        userName: userInfo.name,
        userId: userInfo.userId,
        type: "Text",
        isReply: false,
        rePosition: null,
        reSenderName: null,
        reSenderId: null,
        reType: null,
        reMessageKey: null,
        reText: null,
        reFileUrl: null,
        reMediaLength: null,
        messageTime: time
    };
    if (rKey) {
        message.isReply = true;
        message.rePosition = position;
        message.reSenderId = rMessage.userId;
        message.reSenderName = rMessage.userName;
        message.reType = rMessage.type;
        message.reMessageKey = rKey;
        switch(rMessage.type){
            case "Text":
            case "SongRequest":
                message.reText = rMessage.textMessage;
                break;
            case "Audio":
                message.reMediaLength = getAudioTime(rMessage.audioLength);
                break;
            case "Picture":
            case "Gif":
                message.reFileUrl = rMessage.filePath;
                break;
            case "TextPicture":
            case "TextGif":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.filePath;
                break;
            case "Video":
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
            case "TextVideo":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
        }
    }
    bookmark = {
        type: chatType,
        name: chatInfo.name ? chatInfo.name : null,
        id: chatKey,
        imageUrl: null,
        message: input1,
        messageType: "Text",
        unread_messages: 0,
        lowCaseName: null,
        email: null,
        date: time,
        radioStream: null,
        creatorId: null
    };
    switch(chatType){
        case "RadioChat":
            if (chatInfo.radio_Stream) {
                bookmark.radioStream = chatInfo.radio_Stream;
                bookmark.name = chatInfo.radio_Name;
                bookmark.lowCaseName = chatInfo.radio_Name.toLowerCase();
                if (chatInfo.radio_image) bookmark.imageUrl = chatInfo.radio_image;
            } else {
                bookmark.radioStream = chatInfo.radioStream;
                if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            }
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
        case "privateChat":
            // chatRef = firebase.database()
            //     .ref("PrivateChat/" + userInfo.userId +"/" + chatKey + "/" + messageKey);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            var friendChatRef = firebase.database().ref("PrivateChat/" + chatKey + "/" + userInfo.userId + "/" + messageKey);
            var friendBookmark = {
                type: "privateChat",
                name: userInfo.name,
                id: userInfo.userId,
                imageUrl: userInfo.profileImage,
                message: input1,
                messageType: "Text",
                unread_messages: 0,
                lowCaseName: userInfo.name.toLowerCase(),
                email: userInfo.email,
                date: time,
                radioStream: null,
                creatorId: null
            };
            if (chatInfo.profile_Image) bookmark.imageUrl = chatInfo.profile_Image;
            else if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            if (chatInfo.email) bookmark.email = chatInfo.email;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //request failed
                showToast("Error sending message. Try again later.");
                else {
                    //request sent
                    bmRef.set(bookmark);
                    var friendBmRef = firebase.database().ref("Users/" + chatKey + "/Chat_Bookmarks/" + userInfo.userId);
                    friendChatRef.set(message, function(error) {
                        if (error) //message failed
                        showToast("Error sending friend message. Try again later.");
                        else {
                            //message sent
                            chatRef.child(messageKey).child("sent").set(true);
                            friendBmRef.set(friendBookmark);
                        }
                    });
                //showToast("message sent successfully");
                }
            });
            break;
        case "GroupChat":
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            bookmark.email = chatInfo.email;
            if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            bookmark.creatorId = chatInfo.creatorId;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else {
                    //message sent
                    bmRef.set(bookmark);
                    var groupChatRef = firebase.database().ref("GroupChats/" + chatKey + "/chat");
                    var groupBmRef = firebase.database().ref("Users");
                    for (let participant of groupList)groupChatRef.child(participant).child(messageKey).set(message, function(error) {
                        if (error) //request failed
                        showToast("Error sending message to group. Try again later.");
                        else //request sent
                        groupBmRef.child(participant).child("Chat_Bookmarks").child(chatKey).set(bookmark);
                    });
                //groupChatRef.child()
                //showToast("Petition sent successfully");
                }
            });
            break;
        case "podChat":
            bookmark.name = chatInfo.title ? chatInfo.title : chatInfo.name;
            bookmark.lowCaseName = bookmark.name.toLowerCase();
            bookmark.radioStream = chatInfo.feed ? chatInfo.feed : chatInfo.radioStream;
            bookmark.imageUrl = chatInfo.icon ? chatInfo.icon : chatInfo.imageUrl;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
    }
}
function sendGifMessage(input1, bmRef, chatRef, rMessage, rKey, chatType, userInfo, chatInfo, chatKey, file, groupList) {
    var time = new Date().getTime();
    var messageKey = chatRef.push().key;
    var bookmark;
    var message = {
        textMessage: null,
        userName: userInfo.name,
        userId: userInfo.userId,
        type: "Gif",
        isReply: false,
        rePosition: null,
        reSenderName: null,
        reSenderId: null,
        reType: null,
        reMessageKey: null,
        reText: null,
        reFileUrl: null,
        reMediaLength: null,
        messageTime: time,
        filePath: file,
        isUploaded: true,
        receiverName: chatInfo.name,
        receiverId: chatKey
    };
    if (rKey) {
        message.isReply = true;
        //message.rePosition = position;
        message.reSenderId = rMessage.userId;
        message.reSenderName = rMessage.userName;
        message.reType = rMessage.type;
        message.reMessageKey = rKey;
        switch(rMessage.type){
            case "Text":
            case "SongRequest":
                message.reText = rMessage.textMessage;
                break;
            case "Audio":
                message.reMediaLength = getAudioTime(rMessage.audioLength);
                break;
            case "Picture":
            case "Gif":
                message.reFileUrl = rMessage.filePath;
                break;
            case "TextPicture":
            case "TextGif":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.filePath;
                break;
            case "Video":
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
            case "TextVideo":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
        }
    }
    bookmark = {
        type: chatType,
        name: chatInfo.name,
        id: chatKey,
        imageUrl: null,
        message: null,
        messageType: "Gif",
        unread_messages: 0,
        lowCaseName: null,
        email: null,
        date: time,
        radioStream: null,
        creatorId: null
    };
    if (input1) {
        message.textMessage = input1;
        message.type = "TextGif";
        bookmark.message = input1;
        bookmark.messageType = "TextGif";
    }
    switch(chatType){
        case "RadioChat":
            if (chatInfo.radio_Stream) {
                message.receiverName = chatInfo.radio_Name;
                bookmark.radioStream = chatInfo.radio_Stream;
                bookmark.name = chatInfo.radio_Name;
                bookmark.lowCaseName = chatInfo.radio_Name.toLowerCase();
                if (chatInfo.radio_image) bookmark.imageUrl = chatInfo.radio_image;
            } else {
                bookmark.radioStream = chatInfo.radioStream;
                if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            }
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
        case "privateChat":
            // chatRef = firebase.database()
            //     .ref("PrivateChat/" + userInfo.userId +"/" + chatKey + "/" + messageKey);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            var friendChatRef = firebase.database().ref("PrivateChat/" + chatKey + "/" + userInfo.userId + "/" + messageKey);
            var friendBookmark = {
                type: "privateChat",
                name: userInfo.name,
                id: userInfo.userId,
                imageUrl: userInfo.profileImage,
                message: input1,
                messageType: "Text",
                unread_messages: 0,
                lowCaseName: userInfo.name.toLowerCase(),
                email: userInfo.email,
                date: time,
                radioStream: null,
                creatorId: null
            };
            if (chatInfo.profile_Image) bookmark.imageUrl = chatInfo.profile_Image;
            else if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            if (chatInfo.email) bookmark.email = chatInfo.email;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //request failed
                showToast("Error sending message. Try again later.");
                else {
                    //request sent
                    bmRef.set(bookmark);
                    var friendBmRef = firebase.database().ref("Users/" + chatKey + "/Chat_Bookmarks/" + userInfo.userId);
                    friendChatRef.set(message, function(error) {
                        if (error) //message failed
                        showToast("Error sending friend message. Try again later.");
                        else {
                            //message sent
                            chatRef.child(messageKey).child("sent").set(true);
                            friendBmRef.set(friendBookmark);
                        }
                    });
                //showToast("message sent successfully");
                }
            });
            break;
        case "GroupChat":
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            bookmark.email = chatInfo.email;
            if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            bookmark.creatorId = chatInfo.creatorId;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending petition. Try again later.");
                else {
                    //message sent
                    bmRef.set(bookmark);
                    var groupChatRef = firebase.database().ref("GroupChats/" + chatKey + "/chat");
                    var groupBmRef = firebase.database().ref("Users");
                    for (let participant of groupList)groupChatRef.child(participant).child(messageKey).set(message, function(error) {
                        if (error) //request failed
                        showToast("Error sending message to group. Try again later.");
                        else //request sent
                        groupBmRef.child(participant).child("Chat_Bookmarks").child(chatKey).set(bookmark);
                    });
                //groupChatRef.child()
                //showToast("Petition sent successfully");
                }
            });
            break;
        case "podChat":
            bookmark.name = chatInfo.title ? chatInfo.title : chatInfo.name;
            bookmark.lowCaseName = bookmark.name.toLowerCase();
            bookmark.radioStream = chatInfo.feed;
            bookmark.imageUrl = chatInfo.icon;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
    }
}
function disableButton(btn, disable) {
    if (!btn.style) btn = document.getElementById(btn);
    btn.disabled = disable;
}
function setBackgroundImage(element, image, url) {
    if (!element.style) element = document.getElementById(element);
    if (url) element.style.backgroundImage = "url(" + addSizeToGoogleProfilePic(url) + ")";
    else element.style.backgroundImage = "url('" + image + "')";
}
function addSizeToGoogleProfilePic(url) {
    if (url.indexOf("googleusercontent.com") !== -1 && url.indexOf("?") === -1) return url + "?sz=150";
    return url;
}
function linkify(inputText) {
    if (inputText.includes('name="')) return inputText;
    var replacedText, replacePattern1, replacePattern2, replacePattern3;
    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    //Change email addresses to mailto:: links.
    replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
    return replacedText;
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function deleteCookie(cname) {
    document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
var appId = "d6b72287542044a9bd74d97db02fdd54";
function dragElement(elmnt) {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    if (document.getElementById(elmnt.id + "Header")) /* if present, the header is where you move the DIV from:*/ document.getElementById(elmnt.id + "Header").onmousedown = dragMouseDown;
    else /* otherwise, move the DIV from anywhere inside the DIV:*/ elmnt.onmousedown = dragMouseDown;
    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }
    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        //set element's right position
        //   if(elmnt.style.right != null && elmnt.style.right != "auto"){
        //     var offsetright = window.innerWidth-elmnt.offsetLeft-elmnt.offsetWidth;
        //     elmnt.style.right = (offsetright +pos1) + "px";
        //   }
        // set the element's new position:
        elmnt.style.top = elmnt.offsetTop - pos2 + "px";
        elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }
    function closeDragElement() {
        /* stop moving when mouse button is released:*/ document.onmouseup = null;
        document.onmousemove = null;
    //elmnt.style.right = "auto";
    }
}
function saveLocalFile(fileName, urlFile) {
    let a = document.createElement("a");
    a.style = "display: none";
    document.body.appendChild(a);
    a.href = urlFile;
    a.download = fileName;
    a.click();
    //window.URL.revokeObjectURL(url);
    a.remove();
}
function saveFile(fileName, urlFile) {
    (async ()=>{
        //create new a element
        let a = document.createElement("a");
        // get image as blob
        let response = await fetch(urlFile);
        let file = await response.blob();
        // use download attribute https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes
        a.download = fileName;
        a.href = window.URL.createObjectURL(file);
        //store download url in javascript https://developer.mozilla.org/en-US/docs/Learn/HTML/Howto/Use_data_attributes#JavaScript_access
        a.dataset.downloadurl = [
            "application/octet-stream",
            a.download,
            a.href
        ].join(":");
        //click on element to start download
        a.click();
        a.remove();
    })();
}
function copyText(el, id) {
    var r = document.createRange();
    r.selectNode(el ? el : document.getElementById(id));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
}
function copyInput(el) {
    if (el != null) {
        // Select the text field
        el.select();
        el.setSelectionRange(0, 99999); // For mobile devices
        // Copy the text inside the text field
        navigator.clipboard.writeText(el.value);
    // Alert the copied text
    }
}
const gphClose = (0, _gph5GifDefault.default);
const gphGif = (0, _gph1GifDefault.default);
function getGenre(lang, index) {
    var genre;
    if (lang == null) lang = "en";
    if (lang === "en") genre = genres[index];
    else if (lang === "es") genre = generos[index];
    return genre;
}
function getGenreIndex(lang, genre) {
    if (lang == null) lang = "en";
    if (lang === "en") return genres.indexOf(genre);
    else if (lang === "es") return generos.indexOf(genre);
}
function getGenreList(lang) {
    if (lang == null) lang = "en";
    if (lang === "en") return genres;
    else if (lang === "es") return generos;
}
function getLangList(lang) {
    if (lang == null) lang = "en";
    if (lang === "en") return langs;
    else if (lang === "es") return lengs;
}
function getLangCode(index) {
    return langCode[index];
}
function getLangIndex(code) {
    return langCode.indexOf(code);
}
function getLangName(lang, index) {
    var name;
    if (lang == null) lang = "en";
    if (lang === "en") name = langs[index];
    else if (lang === "es") name = lengs[index];
    return name;
}
function getCountryList(lang) {
    if (lang == null) lang = "en";
    if (lang === "en") return countryList;
    else if (lang === "es") return paisList;
}
function getCountryCode(index) {
    return countryCodeList[index];
}
function getCountryIndex(code) {
    return countryCodeList.indexOf(code);
}
function getCountryName(lang, index) {
    var name;
    if (lang == null) lang = "en";
    if (lang === "en") name = countryList[index];
    else if (lang === "es") name = paisList[index];
    return name;
}
function reformatPaste() {
    $("[contenteditable]").on("paste", function(e) {
        e.preventDefault();
        var text = "";
        if (e.clipboardData || e.originalEvent.clipboardData) text = (e.originalEvent || e).clipboardData.getData("text/plain");
        else if (window.clipboardData) text = window.clipboardData.getData("Text");
        if (document.queryCommandSupported("insertText")) document.execCommand("insertText", false, text);
        else document.execCommand("paste", false, text);
    });
}
function getRandomNum(n) {
    var add = 1, max = 12 - add;
    if (n > max) return generate(max) + generate(n - max);
    max = Math.pow(10, n + add);
    var min1 = max / 10; // Math.pow(10, n) basically
    var number = Math.floor(Math.random() * (max - min1 + 1)) + min1;
    return ("" + number).substring(add);
}
function getPodClass() {
    return podClass;
}
function validateEmail(input1) {
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return reg.test(input1);
}
function validateURL(input1) {
    let reg = /((?:(?:http?|ftp)[s]*:\/\/)?[a-z0-9-%\/\&=?\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?)/gi;
    ///^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return reg.test(input1);
}
function validateLettersNums() {
    let reg = /^([a-zA-Z0-9 ]+)$/;
    return reg.test(input);
}
function removeTags(str) {
    if (str === null || str === "") return;
    else str = str.toString();
    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "");
}
function parseDuration(duration) {
    let remain = duration;
    let days = Math.floor(remain / 86400000);
    remain = remain % 86400000;
    let hours = Math.floor(remain / 3600000);
    remain = remain % 3600000;
    let minutes = Math.floor(remain / 60000);
    remain = remain % 60000;
    let seconds = Math.floor(remain / 1000);
    remain = remain % 1000;
    let milliseconds = remain;
    return {
        days,
        hours,
        minutes,
        seconds,
        milliseconds
    };
}
function formatTimeHMS(o) {
    let hours = o.hours.toString();
    if (hours == "0") hours = "";
    else if (hours.length === 1) hours = "0" + hours + ":";
    else hours = hours + ":";
    let minutes = o.minutes.toString();
    if (minutes.length === 1) minutes = "0" + minutes;
    let seconds = o.seconds.toString();
    if (seconds.length === 1) seconds = "0" + seconds;
    return hours + minutes + ":" + seconds;
}
function formatDurationHMS(duration) {
    let time = parseDuration(duration);
    return formatTimeHMS(time);
}
const DATABASE_IN_APP_PRODUCTS = "https://chat-murcianys-18752.firebaseio.com/";
function scrollRight(parent, btnR, btnL, display, amount) {
    if (parent == null || btnR == null || btnL == null) return;
    parent.scrollLeft += amount ? amount : 100;
    var isEnd = parent.scrollLeft >= parent.scrollWidth - parent.offsetWidth;
    //var isStart = parent.scrollLeft == 0 ? true : false;
    if (isEnd) setDisplay(btnR, "none");
    setDisplay(btnL, display ? display : "block");
}
function scrollLeft(parent, btnR, btnL, display, amount) {
    if (parent == null || btnR == null || btnL == null) return;
    parent.scrollLeft -= amount ? amount : 100;
    //var isEnd = parent.scrollLeft >= parent.scrollWidth - parent.offsetWidth;
    var isStart = parent.scrollLeft == 0 ? true : false;
    if (isStart) setDisplay(btnL, "none");
    setDisplay(btnR, display ? display : "block");
}
function scrollTop(parent, btnT, btnB, display, amount) {
    if (parent == null || btnT == null || btnB == null) return;
    parent.scrollTop -= amount ? amount : 100;
    //var isBottom = parent.scrollTop >= parent.scrollHeight - parent.offsetHeight;
    var isTop = parent.scrollTop == 0 ? true : false;
    if (isTop) setDisplay(btnT, "none");
    setDisplay(btnB, display ? display : "block");
}
function scrollBtm(parent, btnT, btnB, display, amount) {
    if (parent == null || btnT == null || btnB == null) return;
    parent.scrollTop += amount ? amount : 100;
    var isBottom = parent.scrollTop >= parent.scrollHeight - parent.offsetHeight;
    //var isTop = parent.scrollTop == 0 ? true : false;
    if (isBottom) setDisplay(btnB, "none");
    setDisplay(btnT, display ? display : "block");
}
const GroupType = {
    group: "GROUP",
    radio: "RADIO",
    podcast: "PODCAST"
};
initCommonViews();

},{"url:../images/gph5.gif":"kDIuI","url:../images/gph1.gif":"kkSew","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDIuI":[function(require,module,exports) {
module.exports = require("d576137f8796d2b6").getBundleURL("kRWiy") + require("e85a5c4e6a59a850").resolve("c1XkK");

},{"d576137f8796d2b6":"c7Tr5","e85a5c4e6a59a850":"fyJL2"}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"kkSew":[function(require,module,exports) {
module.exports = require("451cbb8d04f57b13").getBundleURL("kRWiy") + require("f09a3063f4e8921a").resolve("7aZnT");

},{"451cbb8d04f57b13":"c7Tr5","f09a3063f4e8921a":"fyJL2"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"kixgL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VanillaJSCarousel", ()=>VanillaJSCarousel);
var _jsComponents = require("@giphy/js-components");
var _jsFetchApi = require("@giphy/js-fetch-api");
const gf = new (0, _jsFetchApi.GiphyFetch)("3S8uTVPgzCqQJ92QGxAz26od8kLOJSOo");
var search;
var type;
var fetchGifs = (offset)=>gf.search(search, {
        offset,
        limit: 10
    });
var url;
class VanillaJSCarousel {
    constructor(mountElement, input, gifClickListener){
        this.buildCarousel = ()=>{
            (0, _jsComponents.renderCarousel)({
                gifHeight: 100,
                user: {},
                fetchGifs,
                gutter: 6,
                onGifClick: (gif)=>{
                    this.mountElement.onclick = function(event) {
                        event.preventDefault();
                    };
                    url = gif.id.toString();
                    //console.log("bit1: " + gif.bitly_url);
                    //console.log("bit2: " + gif.content_url);
                    //console.log("bit3: " + gif.embed_url);
                    //console.log("bit4: " + gif.id);
                    this.gifClickListener.click();
                },
                key: search
            }, this.mountElement);
        };
        this.mountElement = mountElement;
        this.gifClickListener = gifClickListener;
        search = input;
        //fetchGifs
        this.buildCarousel();
    }
    searchGiphy(term) {
        search = term;
        this.buildCarousel();
    }
    getUrl() {
        return url;
    }
}

},{"@giphy/js-components":"8nHv3","@giphy/js-fetch-api":"bCQlO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8nHv3":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderGif = exports.renderCarousel = exports.renderVideo = exports.renderGrid = exports.Video = exports.Grid = exports.Gif = exports.Carousel = void 0;
var js_util_1 = require("247830295d1679ba");
require("663d8dc1706c769d");
var preact_1 = require("f4c320e6d6c83f42");
var carousel_1 = __importDefault(require("de4d93e3fd0fc012"));
var gif_1 = __importDefault(require("e5f73460fbfac800"));
var grid_1 = __importDefault(require("3e113f365ba36838"));
var video_1 = __importDefault(require("2ec3cfb8f78c3067"));
var carousel_2 = require("de4d93e3fd0fc012");
Object.defineProperty(exports, "Carousel", {
    enumerable: true,
    get: function() {
        return __importDefault(carousel_2).default;
    }
});
var gif_2 = require("e5f73460fbfac800");
Object.defineProperty(exports, "Gif", {
    enumerable: true,
    get: function() {
        return __importDefault(gif_2).default;
    }
});
var grid_2 = require("3e113f365ba36838");
Object.defineProperty(exports, "Grid", {
    enumerable: true,
    get: function() {
        return __importDefault(grid_2).default;
    }
});
var video_2 = require("2ec3cfb8f78c3067");
Object.defineProperty(exports, "Video", {
    enumerable: true,
    get: function() {
        return __importDefault(video_2).default;
    }
});
// @ts-ignore
var version = require("512f97de4a26f2c3").version;
// send headers with library type and version
(0, js_util_1.appendGiphySDKRequestHeader)("X-GIPHY-SDK-NAME", "JavascriptSDK");
(0, js_util_1.appendGiphySDKRequestHeader)("X-GIPHY-SDK-VERSION", version);
/**
 * render a grid
 *
 * @param gridProps grid props
 * @param target the node to render into it
 */ var renderGrid = function(gridProps, target) {
    (0, preact_1.render)((0, preact_1.h)(grid_1.default, __assign({}, gridProps)), target);
    return function() {
        return (0, preact_1.render)(null, target);
    };
};
exports.renderGrid = renderGrid;
/**
 * render a video
 *
 * @param carouselProps Carousel props
 * @param target the node to render into it
 */ var renderVideo = function(videoProps, target) {
    (0, preact_1.render)((0, preact_1.h)(video_1.default, __assign({}, videoProps)), target);
    return function() {
        return (0, preact_1.render)(null, target);
    };
};
exports.renderVideo = renderVideo;
/**
 * render a carousel
 *
 * @param carouselProps Carousel props
 * @param target the node to render into it
 */ var renderCarousel = function(carouselProps, target) {
    (0, preact_1.render)((0, preact_1.h)(carousel_1.default, __assign({}, carouselProps)), target);
    return function() {
        return (0, preact_1.render)(null, target);
    };
};
exports.renderCarousel = renderCarousel;
/**
 * render a grid
 *
 * @param gif Gif props
 * @param target the node to render into it
 */ var renderGif = function(gifProps, target) {
    (0, preact_1.render)((0, preact_1.h)(gif_1.default, __assign({}, gifProps)), target);
    return function() {
        return (0, preact_1.render)(null, target);
    };
};
exports.renderGif = renderGif;

},{"247830295d1679ba":"lEFUV","663d8dc1706c769d":"2Vyed","f4c320e6d6c83f42":"hvsRZ","de4d93e3fd0fc012":"8xjLK","e5f73460fbfac800":"63QOc","3e113f365ba36838":"9WoOk","2ec3cfb8f78c3067":"2pyP9","512f97de4a26f2c3":"fvbVk"}],"lEFUV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "Logger", ()=>Logger);
parcelHelpers.export(exports, "appendGiphySDKRequestHeader", ()=>appendGiphySDKRequestHeader);
parcelHelpers.export(exports, "appendGiphySDKRequestParam", ()=>appendGiphySDKRequestParam);
parcelHelpers.export(exports, "bestfit", ()=>bestfit_default);
parcelHelpers.export(exports, "checkIfWebP", ()=>checkIfWebP);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "getAltText", ()=>getAltText);
parcelHelpers.export(exports, "getBestRendition", ()=>getBestRendition);
parcelHelpers.export(exports, "getBestRenditionUrl", ()=>getBestRenditionUrl);
parcelHelpers.export(exports, "getBestVideo", ()=>getBestVideo);
parcelHelpers.export(exports, "getClientRect", ()=>get_client_rect_from_el_default);
parcelHelpers.export(exports, "getGifHeight", ()=>getGifHeight);
parcelHelpers.export(exports, "getGifWidth", ()=>getGifWidth);
parcelHelpers.export(exports, "getGiphySDKRequestHeaders", ()=>getGiphySDKRequestHeaders);
parcelHelpers.export(exports, "getPingbackId", ()=>get_pingback_id_default);
parcelHelpers.export(exports, "getSpecificRendition", ()=>getSpecificRendition);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "setRenditionScaleUpMaxPixels", ()=>setRenditionScaleUpMaxPixels);
parcelHelpers.export(exports, "take", ()=>take);
parcelHelpers.export(exports, "without", ()=>without);
// src/get-pingback-id.ts
var _uuid = require("uuid");
var global = arguments[3];
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
// src/log.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2)=>{
    LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
    LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
    LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
    LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
    return LogLevel2;
})(LogLevel || {});
var Logger = {
    ENABLED: typeof window !== "undefined" && typeof location !== "undefined" && location.search.indexOf("giphy-debug") !== -1,
    LEVEL: 0,
    PREFIX: "GiphyJS",
    debug: (...msg)=>{
        if (Logger.ENABLED && Logger.LEVEL <= 0 /* DEBUG */ ) console.debug(Logger.PREFIX, ...msg);
    },
    info: (...msg)=>{
        if (Logger.ENABLED && Logger.LEVEL <= 1 /* INFO */ ) console.info(Logger.PREFIX, ...msg);
    },
    warn: (...msg)=>{
        if (Logger.ENABLED && Logger.LEVEL <= 2 /* WARN */ ) console.warn(Logger.PREFIX, ...msg);
    },
    error: (...msg)=>{
        if (Logger.ENABLED && Logger.LEVEL <= 3 /* ERROR */ ) console.error(Logger.PREFIX, ...msg);
    }
};
// src/bestfit.ts
var closestArea = (width, height, renditions)=>{
    let currentBest = Infinity;
    let result;
    renditions.forEach((rendition)=>{
        const widthPercentage = rendition.width / width;
        const heightPercentage = rendition.height / height;
        const areaPercentage = widthPercentage * heightPercentage;
        const testBest = Math.abs(1 - areaPercentage);
        if (testBest < currentBest) {
            currentBest = testBest;
            result = rendition;
        }
    });
    return result;
};
var SCALE_UP_MAX_PIXELS = 50;
var setRenditionScaleUpMaxPixels = (pixels)=>{
    Logger.debug(`@giphy/js-util set rendition selection scale up max pixels to ${pixels}`);
    SCALE_UP_MAX_PIXELS = pixels;
};
function bestfit(renditions, width, height, scaleUpMaxPixels = SCALE_UP_MAX_PIXELS) {
    let [largestRendition] = renditions;
    const testRenditions = renditions.filter((rendition)=>{
        if (rendition.width * rendition.height > largestRendition.width * largestRendition.height) largestRendition = rendition;
        return width - rendition.width <= scaleUpMaxPixels && height - rendition.height <= scaleUpMaxPixels;
    });
    if (testRenditions.length === 0) return largestRendition;
    return closestArea(width, height, testRenditions);
}
var bestfit_default = bestfit;
// src/collections.ts
function mapValues(object, mapFn) {
    if (Array.isArray(object)) throw `This map is just for objects, just use array.map for arrays`;
    return Object.keys(object).reduce((result, key)=>{
        result[key] = mapFn(object[key], key);
        return result;
    }, {});
}
function forEach(object, mapFn) {
    if (Array.isArray(object)) throw `This map is just for objects, just use array.forEach for arrays`;
    return Object.keys(object).forEach((key)=>{
        mapFn(object[key], key);
    });
}
function take(arr, count = 0) {
    return arr.slice(0, count);
}
function without(arr, values) {
    return arr.filter((val)=>values.indexOf(val) === -1);
}
function pick(object, pick2) {
    const res = {};
    pick2.forEach((key)=>{
        if (object[key] !== void 0) res[key] = object[key];
    });
    return res;
}
// src/get-client-rect-from-el.ts
var getClientRect = (el)=>{
    let left = 0;
    let top = 0;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    do {
        left += el.offsetLeft;
        top += el.offsetTop;
        el = el.offsetParent;
    }while (el);
    const result = {
        left,
        top,
        width,
        height,
        right: left + width,
        bottom: top + height,
        x: left,
        y: top
    };
    return __spreadProps(__spreadValues({}, result), {
        toJSON: ()=>JSON.stringify(result)
    });
};
var get_client_rect_from_el_default = getClientRect;
var pingbackId = "";
var idLength = 16;
var noUUIDRandom = ()=>{
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for(let i = 0; i < idLength; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
};
var getPingbackId = ()=>{
    if (!pingbackId) {
        try {
            pingbackId = sessionStorage.getItem("giphyPingbackId");
        } catch (_) {}
        if (!pingbackId) {
            const hexTime = /* @__PURE__ */ new Date().getTime().toString(16);
            try {
                pingbackId = `${hexTime}${(0, _uuid.v4)().replace(/-/g, "")}`.substring(0, idLength);
            } catch (error) {
                pingbackId = noUUIDRandom();
            }
            try {
                sessionStorage.setItem("giphyPingbackId", pingbackId);
            } catch (_) {}
        }
    }
    return pingbackId;
};
var get_pingback_id_default = getPingbackId;
// src/webp-check.ts
var SUPPORTS_WEBP = null;
var checkIfWebP = new Promise((resolve)=>{
    if (typeof Image === "undefined") resolve(false);
    const webp = new Image();
    webp.onload = ()=>{
        SUPPORTS_WEBP = true;
        resolve(SUPPORTS_WEBP);
    };
    webp.onerror = ()=>{
        SUPPORTS_WEBP = false;
        resolve(SUPPORTS_WEBP);
    };
    webp.src = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
});
// src/gif-utils.ts
var getSpecificRendition = ({ images, is_sticker: isSticker }, renditionLabel, isStill = false, useVideo = false)=>{
    if (!images || !renditionLabel) return "";
    isStill = isStill && !useVideo;
    const rendition = images[`${renditionLabel}${isStill ? "_still" : ""}`];
    if (rendition) {
        if (isSticker || isStill) return rendition.url;
        const webP = SUPPORTS_WEBP && rendition.webp;
        return useVideo ? rendition.mp4 : webP || rendition.url;
    }
    return "";
};
var getBestVideo = (video, width, height)=>{
    let assets = video == null ? void 0 : video.assets;
    if (assets) {
        assets = __spreadValues({}, assets);
        delete assets.source;
        const filteredAssets = Object.values(assets).sort((a, b)=>a.width - b.width);
        return bestfit_default(filteredAssets, width, height);
    }
};
var getRenditions = (type, images, video)=>type === "video" && video && video.previews && !Object.keys(images).length ? video.previews : images;
var getBestRendition = (images, gifWidth, gifHeight, scaleUpMaxPixels)=>{
    const checkRenditions = pick(images, [
        "original",
        "fixed_width",
        "fixed_height",
        "fixed_width_small",
        "fixed_height_small"
    ]);
    const testImages = Object.entries(checkRenditions).map(([renditionName, val])=>__spreadValues({
            renditionName
        }, val));
    return bestfit_default(testImages, gifWidth, gifHeight, scaleUpMaxPixels);
};
var getBestRenditionUrl = ({ images, video, type }, gifWidth, gifHeight, options = {
    isStill: false,
    useVideo: false
})=>{
    if (!gifWidth || !gifHeight || !images) return "";
    const { useVideo, isStill, scaleUpMaxPixels } = options;
    const renditions = getRenditions(type, images, video);
    const { renditionName } = getBestRendition(renditions, gifWidth, gifHeight, scaleUpMaxPixels);
    const key = `${renditionName}${isStill && !useVideo ? "_still" : ""}`;
    const rendition = renditions[key];
    const match = useVideo ? rendition.mp4 : SUPPORTS_WEBP && rendition.webp ? rendition.webp : rendition.url;
    return match || "";
};
var getGifHeight = ({ images }, gifWidth)=>{
    const { fixed_width } = images;
    if (fixed_width) {
        const { width, height } = fixed_width;
        const aspectRatio = width / height;
        return Math.round(gifWidth / aspectRatio);
    }
    return 0;
};
var getGifWidth = ({ images }, gifHeight)=>{
    const { fixed_width } = images;
    if (fixed_width) {
        const { width, height } = fixed_width;
        const aspectRatio = width / height;
        return Math.round(gifHeight * aspectRatio);
    }
    return 0;
};
var getAltText = ({ alt_text, user, tags = [], is_sticker = false, title = "" })=>{
    if (alt_text) return alt_text;
    if (title) return title;
    const username = user && user.username || "";
    const filteredTags = take(without(tags, [
        "transparent"
    ]), username ? 4 : 5);
    return `${username ? `${username} ` : ``}${filteredTags.join(" ")} ${is_sticker ? "Sticker" : "GIF"}`;
};
// src/sdk-headers.ts
var gl = (typeof window !== "undefined" ? window : global) || {};
gl._GIPHY_SDK_HEADERS_ = gl._GIPHY_SDK_HEADERS_ || (gl.Headers ? new gl.Headers({
    "X-GIPHY-SDK-PLATFORM": "web"
}) : void 0);
var getGiphySDKRequestHeaders = ()=>gl._GIPHY_SDK_HEADERS_;
var appendGiphySDKRequestHeader = (key, value)=>{
    var _a;
    return (_a = getGiphySDKRequestHeaders()) == null ? void 0 : _a.set(key, value);
};
var appendGiphySDKRequestParam = (key, value)=>{
    var _a;
    return (_a = getGiphySDKRequestHeaders()) == null ? void 0 : _a.set(key, value);
};

},{"uuid":"klst7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klst7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"fpA4M","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpA4M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"2mj2P","./rng.js":"lpvWd","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2mj2P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpvWd":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHrI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"d35r5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d35r5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"agidw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agidw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Vyed":[function(require,module,exports) {
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */ (function() {
    "use strict";
    // Exit early if we're not running in a browser.
    if (typeof window !== "object") return;
    // Exit early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
            get: function() {
                return this.intersectionRatio > 0;
            }
        });
        return;
    }
    /**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */ function getFrameElement(doc) {
        try {
            return doc.defaultView && doc.defaultView.frameElement || null;
        } catch (e) {
            // Ignore the error.
            return null;
        }
    }
    /**
 * A local reference to the root document.
 */ var document = function(startDoc) {
        var doc = startDoc;
        var frame = getFrameElement(doc);
        while(frame){
            doc = frame.ownerDocument;
            frame = getFrameElement(doc);
        }
        return doc;
    }(window.document);
    /**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */ var registry = [];
    /**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ var crossOriginUpdater = null;
    /**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */ var crossOriginRect = null;
    /**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */ function IntersectionObserverEntry(entry) {
        this.time = entry.time;
        this.target = entry.target;
        this.rootBounds = ensureDOMRect(entry.rootBounds);
        this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
        this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
        this.isIntersecting = !!entry.intersectionRect;
        // Calculates the intersection ratio.
        var targetRect = this.boundingClientRect;
        var targetArea = targetRect.width * targetRect.height;
        var intersectionRect = this.intersectionRect;
        var intersectionArea = intersectionRect.width * intersectionRect.height;
        // Sets intersection ratio.
        if (targetArea) // Round the intersection ratio to avoid floating point math issues:
        // https://github.com/w3c/IntersectionObserver/issues/324
        this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
        else // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    /**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */ function IntersectionObserver(callback, opt_options) {
        var options = opt_options || {};
        if (typeof callback != "function") throw new Error("callback must be a function");
        if (options.root && options.root.nodeType != 1) throw new Error("root must be an Element");
        // Binds and throttles `this._checkForIntersections`.
        this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
        // Private properties.
        this._callback = callback;
        this._observationTargets = [];
        this._queuedEntries = [];
        this._rootMarginValues = this._parseRootMargin(options.rootMargin);
        // Public properties.
        this.thresholds = this._initThresholds(options.threshold);
        this.root = options.root || null;
        this.rootMargin = this._rootMarginValues.map(function(margin) {
            return margin.value + margin.unit;
        }).join(" ");
        /** @private @const {!Array<!Document>} */ this._monitoringDocuments = [];
        /** @private @const {!Array<function()>} */ this._monitoringUnsubscribes = [];
    }
    /**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */ IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    /**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */ IntersectionObserver.prototype.POLL_INTERVAL = null;
    /**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */ IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    /**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ IntersectionObserver._setupCrossOriginUpdater = function() {
        if (!crossOriginUpdater) /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */ crossOriginUpdater = function(boundingClientRect, intersectionRect) {
            if (!boundingClientRect || !intersectionRect) crossOriginRect = getEmptyRect();
            else crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
            registry.forEach(function(observer) {
                observer._checkForIntersections();
            });
        };
        return crossOriginUpdater;
    };
    /**
 * Resets the cross-origin mode.
 */ IntersectionObserver._resetCrossOriginUpdater = function() {
        crossOriginUpdater = null;
        crossOriginRect = null;
    };
    /**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.observe = function(target) {
        var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
            return item.element == target;
        });
        if (isTargetAlreadyObserved) return;
        if (!(target && target.nodeType == 1)) throw new Error("target must be an Element");
        this._registerInstance();
        this._observationTargets.push({
            element: target,
            entry: null
        });
        this._monitorIntersections(target.ownerDocument);
        this._checkForIntersections();
    };
    /**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.unobserve = function(target) {
        this._observationTargets = this._observationTargets.filter(function(item) {
            return item.element != target;
        });
        this._unmonitorIntersections(target.ownerDocument);
        if (this._observationTargets.length == 0) this._unregisterInstance();
    };
    /**
 * Stops observing all target elements for intersection changes.
 */ IntersectionObserver.prototype.disconnect = function() {
        this._observationTargets = [];
        this._unmonitorAllIntersections();
        this._unregisterInstance();
    };
    /**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */ IntersectionObserver.prototype.takeRecords = function() {
        var records = this._queuedEntries.slice();
        this._queuedEntries = [];
        return records;
    };
    /**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */ IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
        var threshold = opt_threshold || [
            0
        ];
        if (!Array.isArray(threshold)) threshold = [
            threshold
        ];
        return threshold.sort().filter(function(t, i, a) {
            if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) throw new Error("threshold must be a number between 0 and 1 inclusively");
            return t !== a[i - 1];
        });
    };
    /**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */ IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
        var marginString = opt_rootMargin || "0px";
        var margins = marginString.split(/\s+/).map(function(margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
            if (!parts) throw new Error("rootMargin must be specified in pixels or percent");
            return {
                value: parseFloat(parts[1]),
                unit: parts[2]
            };
        });
        // Handles shorthand.
        margins[1] = margins[1] || margins[0];
        margins[2] = margins[2] || margins[0];
        margins[3] = margins[3] || margins[1];
        return margins;
    };
    /**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._monitorIntersections = function(doc) {
        var win = doc.defaultView;
        if (!win) // Already destroyed.
        return;
        if (this._monitoringDocuments.indexOf(doc) != -1) // Already monitoring.
        return;
        // Private state for monitoring.
        var callback = this._checkForIntersections;
        var monitoringInterval = null;
        var domObserver = null;
        // If a poll interval is set, use polling instead of listening to
        // resize and scroll events or DOM mutations.
        if (this.POLL_INTERVAL) monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
        else {
            addEvent(win, "resize", callback, true);
            addEvent(doc, "scroll", callback, true);
            if (this.USE_MUTATION_OBSERVER && "MutationObserver" in win) {
                domObserver = new win.MutationObserver(callback);
                domObserver.observe(doc, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
        }
        this._monitoringDocuments.push(doc);
        this._monitoringUnsubscribes.push(function() {
            // Get the window object again. When a friendly iframe is destroyed, it
            // will be null.
            var win = doc.defaultView;
            if (win) {
                if (monitoringInterval) win.clearInterval(monitoringInterval);
                removeEvent(win, "resize", callback, true);
            }
            removeEvent(doc, "scroll", callback, true);
            if (domObserver) domObserver.disconnect();
        });
        // Also monitor the parent.
        if (doc != (this.root && this.root.ownerDocument || document)) {
            var frame = getFrameElement(doc);
            if (frame) this._monitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
        var index = this._monitoringDocuments.indexOf(doc);
        if (index == -1) return;
        var rootDoc = this.root && this.root.ownerDocument || document;
        // Check if any dependent targets are still remaining.
        var hasDependentTargets = this._observationTargets.some(function(item) {
            var itemDoc = item.element.ownerDocument;
            // Target is in this context.
            if (itemDoc == doc) return true;
            // Target is nested in this context.
            while(itemDoc && itemDoc != rootDoc){
                var frame = getFrameElement(itemDoc);
                itemDoc = frame && frame.ownerDocument;
                if (itemDoc == doc) return true;
            }
            return false;
        });
        if (hasDependentTargets) return;
        // Unsubscribe.
        var unsubscribe = this._monitoringUnsubscribes[index];
        this._monitoringDocuments.splice(index, 1);
        this._monitoringUnsubscribes.splice(index, 1);
        unsubscribe();
        // Also unmonitor the parent.
        if (doc != rootDoc) {
            var frame = getFrameElement(doc);
            if (frame) this._unmonitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorAllIntersections = function() {
        var unsubscribes = this._monitoringUnsubscribes.slice(0);
        this._monitoringDocuments.length = 0;
        this._monitoringUnsubscribes.length = 0;
        for(var i = 0; i < unsubscribes.length; i++)unsubscribes[i]();
    };
    /**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */ IntersectionObserver.prototype._checkForIntersections = function() {
        if (!this.root && crossOriginUpdater && !crossOriginRect) // Cross origin monitoring, but no initial data available yet.
        return;
        var rootIsInDom = this._rootIsInDom();
        var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
        this._observationTargets.forEach(function(item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);
            var rootContainsTarget = this._rootContainsTarget(target);
            var oldEntry = item.entry;
            var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);
            var newEntry = item.entry = new IntersectionObserverEntry({
                time: now(),
                target: target,
                boundingClientRect: targetRect,
                rootBounds: crossOriginUpdater && !this.root ? null : rootRect,
                intersectionRect: intersectionRect
            });
            if (!oldEntry) this._queuedEntries.push(newEntry);
            else if (rootIsInDom && rootContainsTarget) // If the new entry intersection ratio has crossed any of the
            // thresholds, add a new entry.
            {
                if (this._hasCrossedThreshold(oldEntry, newEntry)) this._queuedEntries.push(newEntry);
            } else // If the root is not in the DOM or target is not contained within
            // root but the previous entry for this target had an intersection,
            // add a new record indicating removal.
            if (oldEntry && oldEntry.isIntersecting) this._queuedEntries.push(newEntry);
        }, this);
        if (this._queuedEntries.length) this._callback(this.takeRecords(), this);
    };
    /**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */ IntersectionObserver.prototype._computeTargetAndRootIntersection = function(target, targetRect, rootRect) {
        // If the element isn't displayed, an intersection can't happen.
        if (window.getComputedStyle(target).display == "none") return;
        var intersectionRect = targetRect;
        var parent = getParentNode(target);
        var atRoot = false;
        while(!atRoot && parent){
            var parentRect = null;
            var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
            // If the parent isn't displayed, an intersection can't happen.
            if (parentComputedStyle.display == "none") return null;
            if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
                atRoot = true;
                if (parent == this.root || parent == document) {
                    if (crossOriginUpdater && !this.root) {
                        if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                            // A 0-size cross-origin intersection means no-intersection.
                            parent = null;
                            parentRect = null;
                            intersectionRect = null;
                        } else parentRect = crossOriginRect;
                    } else parentRect = rootRect;
                } else {
                    // Check if there's a frame that can be navigated to.
                    var frame = getParentNode(parent);
                    var frameRect = frame && getBoundingClientRect(frame);
                    var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
                    if (frameRect && frameIntersect) {
                        parent = frame;
                        parentRect = convertFromParentRect(frameRect, frameIntersect);
                    } else {
                        parent = null;
                        intersectionRect = null;
                    }
                }
            } else {
                // If the element has a non-visible overflow, and it's not the <body>
                // or <html> element, update the intersection rect.
                // Note: <body> and <html> cannot be clipped to a rect that's not also
                // the document rect, so no need to compute a new intersection.
                var doc = parent.ownerDocument;
                if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != "visible") parentRect = getBoundingClientRect(parent);
            }
            // If either of the above conditionals set a new parentRect,
            // calculate new intersection data.
            if (parentRect) intersectionRect = computeRectIntersection(parentRect, intersectionRect);
            if (!intersectionRect) break;
            parent = parent && getParentNode(parent);
        }
        return intersectionRect;
    };
    /**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */ IntersectionObserver.prototype._getRootRect = function() {
        var rootRect;
        if (this.root) rootRect = getBoundingClientRect(this.root);
        else {
            // Use <html>/<body> instead of window since scroll bars affect size.
            var html = document.documentElement;
            var body = document.body;
            rootRect = {
                top: 0,
                left: 0,
                right: html.clientWidth || body.clientWidth,
                width: html.clientWidth || body.clientWidth,
                bottom: html.clientHeight || body.clientHeight,
                height: html.clientHeight || body.clientHeight
            };
        }
        return this._expandRectByRootMargin(rootRect);
    };
    /**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */ IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
        var margins = this._rootMarginValues.map(function(margin, i) {
            return margin.unit == "px" ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
        });
        var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3]
        };
        newRect.width = newRect.right - newRect.left;
        newRect.height = newRect.bottom - newRect.top;
        return newRect;
    };
    /**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */ IntersectionObserver.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
        // To make comparing easier, an entry that has a ratio of 0
        // but does not actually intersect is given a value of -1
        var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
        var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
        // Ignore unchanged ratios
        if (oldRatio === newRatio) return;
        for(var i = 0; i < this.thresholds.length; i++){
            var threshold = this.thresholds[i];
            // Return true if an entry matches a threshold or if the new ratio
            // and the old ratio are on the opposite sides of a threshold.
            if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) return true;
        }
    };
    /**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */ IntersectionObserver.prototype._rootIsInDom = function() {
        return !this.root || containsDeep(document, this.root);
    };
    /**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */ IntersectionObserver.prototype._rootContainsTarget = function(target) {
        return containsDeep(this.root || document, target) && (!this.root || this.root.ownerDocument == target.ownerDocument);
    };
    /**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */ IntersectionObserver.prototype._registerInstance = function() {
        if (registry.indexOf(this) < 0) registry.push(this);
    };
    /**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */ IntersectionObserver.prototype._unregisterInstance = function() {
        var index = registry.indexOf(this);
        if (index != -1) registry.splice(index, 1);
    };
    /**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */ function now() {
        return window.performance && performance.now && performance.now();
    }
    /**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */ function throttle(fn, timeout) {
        var timer = null;
        return function() {
            if (!timer) timer = setTimeout(function() {
                fn();
                timer = null;
            }, timeout);
        };
    }
    /**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */ function addEvent(node, event, fn, opt_useCapture) {
        if (typeof node.addEventListener == "function") node.addEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.attachEvent == "function") node.attachEvent("on" + event, fn);
    }
    /**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */ function removeEvent(node, event, fn, opt_useCapture) {
        if (typeof node.removeEventListener == "function") node.removeEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.detatchEvent == "function") node.detatchEvent("on" + event, fn);
    }
    /**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */ function computeRectIntersection(rect1, rect2) {
        var top = Math.max(rect1.top, rect2.top);
        var bottom = Math.min(rect1.bottom, rect2.bottom);
        var left = Math.max(rect1.left, rect2.left);
        var right = Math.min(rect1.right, rect2.right);
        var width = right - left;
        var height = bottom - top;
        return width >= 0 && height >= 0 && {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        } || null;
    }
    /**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */ function getBoundingClientRect(el) {
        var rect;
        try {
            rect = el.getBoundingClientRect();
        } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
        }
        if (!rect) return getEmptyRect();
        // Older IE
        if (!(rect.width && rect.height)) rect = {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        return rect;
    }
    /**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */ function getEmptyRect() {
        return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
        };
    }
    /**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */ function ensureDOMRect(rect) {
        // A `DOMRect` object has `x` and `y` fields.
        if (!rect || "x" in rect) return rect;
        // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
        // for internally calculated Rect objects. For the purposes of
        // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
        // for these fields.
        return {
            top: rect.top,
            y: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            x: rect.left,
            right: rect.right,
            width: rect.width,
            height: rect.height
        };
    }
    /**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */ function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
        var top = parentIntersectionRect.top - parentBoundingRect.top;
        var left = parentIntersectionRect.left - parentBoundingRect.left;
        return {
            top: top,
            left: left,
            height: parentIntersectionRect.height,
            width: parentIntersectionRect.width,
            bottom: top + parentIntersectionRect.height,
            right: left + parentIntersectionRect.width
        };
    }
    /**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */ function containsDeep(parent, child) {
        var node = child;
        while(node){
            if (node == parent) return true;
            node = getParentNode(node);
        }
        return false;
    }
    /**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */ function getParentNode(node) {
        var parent = node.parentNode;
        if (node.nodeType == /* DOCUMENT */ 9 && node != document) // If this node is a document node, look for the embedding frame.
        return getFrameElement(node);
        if (parent && parent.nodeType == 11 && parent.host) // If the parent is a shadow root, return the host element.
        return parent.host;
        if (parent && parent.assignedSlot) // If the parent is distributed in a <slot>, return the parent of a slot.
        return parent.assignedSlot.parentNode;
        return parent;
    }
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

},{}],"hvsRZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>M);
parcelHelpers.export(exports, "hydrate", ()=>O);
parcelHelpers.export(exports, "createElement", ()=>v);
parcelHelpers.export(exports, "h", ()=>v);
parcelHelpers.export(exports, "Fragment", ()=>p);
parcelHelpers.export(exports, "createRef", ()=>y);
parcelHelpers.export(exports, "isValidElement", ()=>l);
parcelHelpers.export(exports, "Component", ()=>d);
parcelHelpers.export(exports, "cloneElement", ()=>S);
parcelHelpers.export(exports, "createContext", ()=>q);
parcelHelpers.export(exports, "toChildArray", ()=>b);
parcelHelpers.export(exports, "__u", ()=>I);
parcelHelpers.export(exports, "options", ()=>n);
var n, l, u, i, t, o, r, f = {}, e = [], c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function s(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function a(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function v(n, l, u) {
    var i, t, o, r = arguments, f = {};
    for(o in l)"key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o];
    if (arguments.length > 3) for(u = [
        u
    ], o = 3; o < arguments.length; o++)u.push(r[o]);
    if (null != u && (f.children = u), "function" == typeof n && null != n.defaultProps) for(o in n.defaultProps)void 0 === f[o] && (f[o] = n.defaultProps[o]);
    return h(n, f, i, t, null);
}
function h(l, u, i, t, o) {
    var r = {
        type: l,
        props: u,
        key: i,
        ref: t,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: o
    };
    return null == o && (r.__v = r), null != n.vnode && n.vnode(r), r;
}
function y() {
    return {
        current: null
    };
}
function p(n) {
    return n.children;
}
function d(n, l) {
    this.props = n, this.context = l;
}
function _(n, l) {
    if (null == l) return n.__ ? _(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? _(n) : null;
}
function w(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return w(n);
    }
}
function k(l) {
    (!l.__d && (l.__d = !0) && u.push(l) && !m.__r++ || t !== n.debounceRendering) && ((t = n.debounceRendering) || i)(m);
}
function m() {
    for(var n; m.__r = u.length;)n = u.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), u = [], n.some(function(n) {
        var l, u, i, t, o, r, f;
        n.__d && (r = (o = (l = n).__v).__e, (f = l.__P) && (u = [], (i = s({}, o)).__v = i, t = T(f, o, i, l.__n, void 0 !== f.ownerSVGElement, null, u, null == r ? _(o) : r), $(u, o), t != r && w(o)));
    });
}
function g(n, l, u, i, t, o, r, c, s, v) {
    var y, d, w, k, m, g, b, A = i && i.__k || e, P = A.length;
    for(s == f && (s = null != r ? r[0] : P ? _(i, 0) : null), u.__k = [], y = 0; y < l.length; y++)if (null != (k = u.__k[y] = null == (k = l[y]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k ? h(null, k, null, null, k) : Array.isArray(k) ? h(p, {
        children: k
    }, null, null, null) : null != k.__e || null != k.__c ? h(k.type, k.props, k.key, null, k.__v) : k)) {
        if (k.__ = u, k.__b = u.__b + 1, null === (w = A[y]) || w && k.key == w.key && k.type === w.type) A[y] = void 0;
        else for(d = 0; d < P; d++){
            if ((w = A[d]) && k.key == w.key && k.type === w.type) {
                A[d] = void 0;
                break;
            }
            w = null;
        }
        m = T(n, k, w = w || f, t, o, r, c, s, v), (d = k.ref) && w.ref != d && (b || (b = []), w.ref && b.push(w.ref, null, k), b.push(d, k.__c || m, k)), null != m ? (null == g && (g = m), s = x(n, k, w, A, r, m, s), v || "option" != u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && w.__e == s && s.parentNode != n && (s = _(w));
    }
    if (u.__e = g, null != r && "function" != typeof u.type) for(y = r.length; y--;)null != r[y] && a(r[y]);
    for(y = P; y--;)null != A[y] && I(A[y], A[y]);
    if (b) for(y = 0; y < b.length; y++)H(b[y], b[++y], b[++y]);
}
function b(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        b(n, l);
    }) : l.push(n)), l;
}
function x(n, l, u, i, t, o, r) {
    var f, e, c;
    if (void 0 !== l.__d) f = l.__d, l.__d = void 0;
    else if (t == u || o != r || null == o.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(o), f = null;
    else {
        for(e = r, c = 0; (e = e.nextSibling) && c < i.length; c += 2)if (e == o) break n;
        n.insertBefore(o, r), f = r;
    }
    return void 0 !== f ? f : o.nextSibling;
}
function A(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || C(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || C(n, o, l[o], u[o], i);
}
function P(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || c.test(l) ? u : u + "px";
}
function C(n, l, u, i, t) {
    var o, r;
    if (t && "className" == l && (l = "class"), "style" === l) {
        if ("string" == typeof u) n.style = u;
        else {
            if ("string" == typeof i && (n.style = i = ""), i) for(l in i)u && l in u || P(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || P(n.style, l, u[l]);
        }
    } else "o" === l[0] && "n" === l[1] ? (o = l !== (l = l.replace(/Capture$/, "")), (r = l.toLowerCase()) in n && (l = r), l = l.slice(2), n.l || (n.l = {}), n.l[l] = u, u ? i || n.addEventListener(l, z, o) : n.removeEventListener(l, z, o)) : "list" !== l && "tagName" !== l && "form" !== l && "type" !== l && "size" !== l && "download" !== l && "href" !== l && !t && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u && !/^ar/.test(l) ? n.removeAttribute(l) : n.setAttribute(l, u));
}
function z(l) {
    this.l[l.type](n.event ? n.event(l) : l);
}
function N(n, l, u) {
    var i, t;
    for(i = 0; i < n.__k.length; i++)(t = n.__k[i]) && (t.__ = n, t.__e && ("function" == typeof t.type && t.__k.length > 1 && N(t, l, u), l = x(u, t, t, n.__k, null, t.__e, l), "function" == typeof n.type && (n.__d = l)));
}
function T(l, u, i, t, o, r, f, e, c) {
    var a, v, h, y, _, w, k, m, b, x, A, P = u.type;
    if (void 0 !== u.constructor) return null;
    (a = n.__b) && a(u);
    try {
        n: if ("function" == typeof P) {
            if (m = u.props, b = (a = P.contextType) && t[a.__c], x = a ? b ? b.props.value : a.__ : t, i.__c ? k = (v = u.__c = i.__c).__ = v.__E : ("prototype" in P && P.prototype.render ? u.__c = v = new P(m, x) : (u.__c = v = new d(m, x), v.constructor = P, v.render = L), b && b.sub(v), v.props = m, v.state || (v.state = {}), v.context = x, v.__n = t, h = v.__d = !0, v.__h = []), null == v.__s && (v.__s = v.state), null != P.getDerivedStateFromProps && (v.__s == v.state && (v.__s = s({}, v.__s)), s(v.__s, P.getDerivedStateFromProps(m, v.__s))), y = v.props, _ = v.state, h) null == P.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && v.__h.push(v.componentDidMount);
            else {
                if (null == P.getDerivedStateFromProps && m !== y && null != v.componentWillReceiveProps && v.componentWillReceiveProps(m, x), !v.__e && null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(m, v.__s, x) || u.__v === i.__v) {
                    v.props = m, v.state = v.__s, u.__v !== i.__v && (v.__d = !1), v.__v = u, u.__e = i.__e, u.__k = i.__k, v.__h.length && f.push(v), N(u, e, l);
                    break n;
                }
                null != v.componentWillUpdate && v.componentWillUpdate(m, v.__s, x), null != v.componentDidUpdate && v.__h.push(function() {
                    v.componentDidUpdate(y, _, w);
                });
            }
            v.context = x, v.props = m, v.state = v.__s, (a = n.__r) && a(u), v.__d = !1, v.__v = u, v.__P = l, a = v.render(v.props, v.state, v.context), v.state = v.__s, null != v.getChildContext && (t = s(s({}, t), v.getChildContext())), h || null == v.getSnapshotBeforeUpdate || (w = v.getSnapshotBeforeUpdate(y, _)), A = null != a && a.type == p && null == a.key ? a.props.children : a, g(l, Array.isArray(A) ? A : [
                A
            ], u, i, t, o, r, f, e, c), v.base = u.__e, v.__h.length && f.push(v), k && (v.__E = v.__ = null), v.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = j(i.__e, u, i, t, o, r, f, c);
        (a = n.diffed) && a(u);
    } catch (l) {
        u.__v = null, n.__e(l, u, i);
    }
    return u.__e;
}
function $(l, u) {
    n.__c && n.__c(u, l), l.some(function(u) {
        try {
            l = u.__h, u.__h = [], l.some(function(n) {
                n.call(u);
            });
        } catch (l) {
            n.__e(l, u.__v);
        }
    });
}
function j(n, l, u, i, t, o, r, c) {
    var s, a, v, h, y, p = u.props, d = l.props;
    if (t = "svg" === l.type || t, null != o) {
        for(s = 0; s < o.length; s++)if (null != (a = o[s]) && ((null === l.type ? 3 === a.nodeType : a.localName === l.type) || n == a)) {
            n = a, o[s] = null;
            break;
        }
    }
    if (null == n) {
        if (null === l.type) return document.createTextNode(d);
        n = t ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type, d.is && {
            is: d.is
        }), o = null, c = !1;
    }
    if (null === l.type) p !== d && n.data !== d && (n.data = d);
    else {
        if (null != o && (o = e.slice.call(n.childNodes)), v = (p = u.props || f).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !c) {
            if (null != o) for(p = {}, y = 0; y < n.attributes.length; y++)p[n.attributes[y].name] = n.attributes[y].value;
            (h || v) && (h && v && h.__html == v.__html || (n.innerHTML = h && h.__html || ""));
        }
        A(n, d, p, t, c), h ? l.__k = [] : (s = l.props.children, g(n, Array.isArray(s) ? s : [
            s
        ], l, u, i, "foreignObject" !== l.type && t, o, r, f, c)), c || ("value" in d && void 0 !== (s = d.value) && s !== n.value && C(n, "value", s, p.value, !1), "checked" in d && void 0 !== (s = d.checked) && s !== n.checked && C(n, "checked", s, p.checked, !1));
    }
    return n;
}
function H(l, u, i) {
    try {
        "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
        n.__e(l, i);
    }
}
function I(l, u, i) {
    var t, o, r;
    if (n.unmount && n.unmount(l), (t = l.ref) && (t.current && t.current !== l.__e || H(t, null, u)), i || "function" == typeof l.type || (i = null != (o = l.__e)), l.__e = l.__d = void 0, null != (t = l.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (l) {
            n.__e(l, u);
        }
        t.base = t.__P = null;
    }
    if (t = l.__k) for(r = 0; r < t.length; r++)t[r] && I(t[r], u, i);
    null != o && a(o);
}
function L(n, l, u) {
    return this.constructor(n, u);
}
function M(l, u, i) {
    var t, r, c;
    n.__ && n.__(l, u), r = (t = i === o) ? null : i && i.__k || u.__k, l = v(p, null, [
        l
    ]), c = [], T(u, (t ? u : i || u).__k = l, r || f, f, void 0 !== u.ownerSVGElement, i && !t ? [
        i
    ] : r ? null : u.childNodes.length ? e.slice.call(u.childNodes) : null, c, i || f, t), $(c, l);
}
function O(n, l) {
    M(n, l, o);
}
function S(n, l, u) {
    var i, t, o, r = arguments, f = s({}, n.props);
    for(o in l)"key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o];
    if (arguments.length > 3) for(u = [
        u
    ], o = 3; o < arguments.length; o++)u.push(r[o]);
    return null != u && (f.children = u), h(n.type, f, i || n.key, t || n.ref, null);
}
function q(n, l) {
    var u = {
        __c: l = "__cC" + r++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n, u, i) {
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(k);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
n = {
    __e: function(n, l) {
        for(var u, i; l = l.__;)if ((u = l.__c) && !u.__) try {
            if (u.constructor && null != u.constructor.getDerivedStateFromError && (i = !0, u.setState(u.constructor.getDerivedStateFromError(n))), null != u.componentDidCatch && (i = !0, u.componentDidCatch(n)), i) return k(u.__E = u);
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, l = function(n) {
    return null != n && void 0 === n.constructor;
}, d.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = s({}, this.state), "function" == typeof n && (n = n(s({}, u), this.props)), n && s(u, n), null != n && this.__v && (l && this.__h.push(l), k(this));
}, d.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), k(this));
}, d.prototype.render = p, u = [], i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, m.__r = 0, o = f, r = 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xjLK":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var js_fetch_api_1 = require("9e235a6fdd55dabc");
var js_util_1 = require("365d40af55a889f1");
var css_1 = require("4b290769108925f9");
var preact_1 = require("57d551da4039a067");
var throttle_debounce_1 = require("530530f8edeefeba");
var observer_1 = __importDefault(require("2da9ceb333a5dd27"));
var gif_1 = __importDefault(require("260c5fc0123275c3"));
var pingback_context_manager_1 = __importDefault(require("16e6cf1c27352b1c"));
var carouselCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n    position: relative;\n"
], [
    "\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n    position: relative;\n"
])));
var carouselItemCss = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject([
    "\n    display: inline-block;\n    list-style: none;\n    /* make sure gifs are fully visible with a scrollbar */\n    margin-bottom: 1px;\n    &:first-of-type {\n        margin-left: 0;\n    }\n"
], [
    "\n    display: inline-block;\n    list-style: none;\n    /* make sure gifs are fully visible with a scrollbar */\n    margin-bottom: 1px;\n    &:first-of-type {\n        margin-left: 0;\n    }\n"
])));
var loaderContainerCss = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject([
    "\n    display: inline-block;\n"
], [
    "\n    display: inline-block;\n"
])));
var loaderCss = (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject([
    "\n    width: 30px;\n    display: inline-block;\n"
], [
    "\n    width: 30px;\n    display: inline-block;\n"
])));
var defaultProps = Object.freeze({
    gutter: 6,
    user: {}
});
var initialState = Object.freeze({
    isFetching: false,
    numberOfGifs: 0,
    gifs: [],
    isLoaderVisible: true,
    isDoneFetching: false
});
var Carousel = /** @class */ function(_super) {
    __extends(Carousel, _super);
    function Carousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.paginator = (0, js_fetch_api_1.gifPaginator)(_this.props.fetchGifs);
        _this.onLoaderVisible = function(isVisible) {
            _this.setState({
                isLoaderVisible: isVisible
            }, _this.onFetch);
        };
        _this.onFetch = (0, throttle_debounce_1.debounce)(100, function() {
            return __awaiter(_this, void 0, void 0, function() {
                var _a, isFetching, isLoaderVisible, existingGifs, gifs, error_1, onGifsFetched;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _a = this.state, isFetching = _a.isFetching, isLoaderVisible = _a.isLoaderVisible, existingGifs = _a.gifs;
                            if (!(!isFetching && isLoaderVisible)) return [
                                3 /*break*/ ,
                                5
                            ];
                            this.setState({
                                isFetching: true
                            });
                            gifs = void 0;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.paginator()
                            ];
                        case 2:
                            gifs = _b.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            error_1 = _b.sent();
                            this.setState({
                                isFetching: false
                            });
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            if (gifs) {
                                if (existingGifs.length === gifs.length) this.setState({
                                    isDoneFetching: true
                                });
                                else {
                                    this.setState({
                                        gifs: gifs,
                                        isFetching: false
                                    });
                                    onGifsFetched = this.props.onGifsFetched;
                                    if (onGifsFetched) onGifsFetched(gifs);
                                    this.onFetch();
                                }
                            }
                            _b.label = 5;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        return _this;
    }
    Carousel.prototype.componentDidMount = function() {
        this.onFetch();
    };
    Carousel.prototype.render = function(_a, _b) {
        var onGifVisible = _a.onGifVisible, onGifRightClick = _a.onGifRightClick, gifHeight = _a.gifHeight, gifWidth = _a.gifWidth, gutter = _a.gutter, _c = _a.className, className = _c === void 0 ? Carousel.className : _c, onGifClick = _a.onGifClick, onGifHover = _a.onGifHover, onGifKeyPress = _a.onGifKeyPress, onGifSeen = _a.onGifSeen, user = _a.user, noResultsMessage = _a.noResultsMessage, hideAttribution = _a.hideAttribution, noLink = _a.noLink, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, borderRadius = _a.borderRadius;
        var gifs = _b.gifs;
        var showLoader = gifs.length > 0;
        var marginCss = (0, css_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject([
            "\n            margin-left: ",
            "px;\n        "
        ], [
            "\n            margin-left: ",
            "px;\n        "
        ])), gutter);
        var gifHeightCss = (0, css_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject([
            "\n            height: ",
            "px;\n        "
        ], [
            "\n            height: ",
            "px;\n        "
        ])), gifHeight);
        var containerCss = (0, css_1.cx)(className, carouselCss);
        var gifCss = (0, css_1.cx)(carouselItemCss, marginCss);
        return (0, preact_1.h)(pingback_context_manager_1.default, {
            attributes: {
                layout_type: "CAROUSEL"
            }
        }, (0, preact_1.h)("div", {
            class: containerCss
        }, gifs.map(function(gif) {
            return (0, preact_1.h)(gif_1.default, {
                className: gifCss,
                gif: gif,
                key: gif.id,
                tabIndex: tabIndex,
                width: gifWidth || (0, js_util_1.getGifWidth)(gif, gifHeight),
                height: gifHeight,
                onGifClick: onGifClick,
                onGifHover: onGifHover,
                onGifKeyPress: onGifKeyPress,
                onGifSeen: onGifSeen,
                onGifVisible: onGifVisible,
                onGifRightClick: onGifRightClick,
                user: user,
                hideAttribution: hideAttribution,
                noLink: noLink,
                borderRadius: borderRadius
            });
        }), !showLoader && gifs.length === 0 && noResultsMessage, showLoader && (0, preact_1.h)(observer_1.default, {
            className: loaderContainerCss,
            onVisibleChange: this.onLoaderVisible
        }, (0, preact_1.h)("div", {
            className: (0, css_1.cx)(loaderCss, gifHeightCss)
        }))));
    };
    Carousel.className = "giphy-carousel";
    Carousel.defaultProps = defaultProps;
    return Carousel;
}(preact_1.Component);
exports.default = Carousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

},{"9e235a6fdd55dabc":"bCQlO","365d40af55a889f1":"lEFUV","4b290769108925f9":"awUBr","57d551da4039a067":"hvsRZ","530530f8edeefeba":"kbogy","2da9ceb333a5dd27":"3eCpt","260c5fc0123275c3":"63QOc","16e6cf1c27352b1c":"g219r"}],"bCQlO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GiphyFetch", ()=>(0, _apiDefault.default));
parcelHelpers.export(exports, "serverUrl", ()=>(0, _constants.serverUrl));
parcelHelpers.export(exports, "setServerUrl", ()=>(0, _constants.setServerUrl));
parcelHelpers.export(exports, "FetchError", ()=>(0, _fetchErrorDefault.default));
parcelHelpers.export(exports, "gifPaginator", ()=>(0, _paginator.gifPaginator));
parcelHelpers.export(exports, "request", ()=>(0, _requestDefault.default));
var _jsUtil = require("@giphy/js-util");
var _api = require("./api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _constants = require("./constants");
var _fetchError = require("./fetch-error");
var _fetchErrorDefault = parcelHelpers.interopDefault(_fetchError);
var _optionTypes = require("./option-types");
parcelHelpers.exportAll(_optionTypes, exports);
var _paginator = require("./paginator");
var _request = require("./request");
var _requestDefault = parcelHelpers.interopDefault(_request);
var _resultTypes = require("./result-types");
parcelHelpers.exportAll(_resultTypes, exports);
var _a;
var version = require("50eaeb70ec4f31d3").version;
// since we have multiple SDKs, we're defining a hieracrchy
// Fetch API is lowest
if (!((_a = (0, _jsUtil.getGiphySDKRequestHeaders)()) === null || _a === void 0 ? void 0 : _a.get("X-GIPHY-SDK-NAME"))) {
    // send headers with library type and version
    (0, _jsUtil.appendGiphySDKRequestHeader)("X-GIPHY-SDK-NAME", "FetchAPI");
    (0, _jsUtil.appendGiphySDKRequestHeader)("X-GIPHY-SDK-VERSION", version);
}

},{"@giphy/js-util":"lEFUV","./api":"4lxIu","./constants":"jgLnO","./fetch-error":"ehR0g","./option-types":"87qnT","./paginator":"5Jmq6","./request":"5bjjQ","./result-types":"98BXO","50eaeb70ec4f31d3":"dTC97","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4lxIu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GiphyFetch", ()=>GiphyFetch);
/* eslint-disable no-dupe-class-members */ var _jsUtil = require("@giphy/js-util");
var _qs = require("qs");
var _qsDefault = parcelHelpers.interopDefault(_qs);
var _gif = require("./normalize/gif");
var _request = require("./request");
var _requestDefault = parcelHelpers.interopDefault(_request);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var getType = function(options) {
    return options && options.type ? options.type : "gifs";
};
/**
 * @class GiphyFetch
 * @param {string} apiKey
 */ var GiphyFetch = /** @class */ function() {
    function GiphyFetch(apiKey) {
        var _this = this;
        /**
         * @hidden
         */ this.getQS = function(options) {
            if (options === void 0) options = {};
            return (0, _qsDefault.default).stringify(__assign(__assign({}, options), {
                api_key: _this.apiKey,
                pingback_id: (0, _jsUtil.getPingbackId)()
            }));
        };
        this.apiKey = apiKey;
    }
    /**
     * A list of categories
     *
     * @param {CategoriesOptions} [options]
     * @returns {Promise<CategoriesResult>}
     */ GiphyFetch.prototype.categories = function(options) {
        return (0, _requestDefault.default)("gifs/categories?".concat(this.getQS(options)));
    };
    /**
     * Get a single gif by a id
     * @param {string} id
     * @returns {Promise<GifsResult>}
     **/ GiphyFetch.prototype.gif = function(id) {
        return (0, _requestDefault.default)("gifs/".concat(id, "?").concat(this.getQS()), {
            normalizer: (0, _gif.normalizeGif)
        });
    };
    GiphyFetch.prototype.gifs = function(arg1, arg2) {
        if (Array.isArray(arg1)) return (0, _requestDefault.default)("gifs?".concat(this.getQS({
            ids: arg1.join(",")
        })), {
            normalizer: (0, _gif.normalizeGifs)
        });
        return (0, _requestDefault.default)("gifs/categories/".concat(arg1, "/").concat(arg2, "?").concat(this.getQS()), {
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    GiphyFetch.prototype.emoji = function(options) {
        return (0, _requestDefault.default)("emoji?".concat(this.getQS(options)), {
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    /**
     * Returns a list of all the default emoji variations
     *
     * @param {PaginationOptions} options
     * @returns {Promise<GifsResult>}
     **/ GiphyFetch.prototype.emojiDefaultVariations = function(options) {
        return (0, _requestDefault.default)("emoji?".concat(this.getQS(options)), {
            apiVersion: 2,
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    /**
     * Returns a list of gifs representing all the variations for the emoji
     *
     * @param {string} id
     * @returns {Promise<NonPaginatedGifsResult>}
     **/ GiphyFetch.prototype.emojiVariations = function(id) {
        return (0, _requestDefault.default)("emoji/".concat(id, "/variations?").concat(this.getQS()), {
            apiVersion: 2,
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    GiphyFetch.prototype.animate = function(text, options) {
        if (options === void 0) options = {};
        var qsParams = this.getQS(__assign(__assign({}, options), {
            m: text
        }));
        return (0, _requestDefault.default)("text/animate?".concat(qsParams), {
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    /**
     * @param term: string The term you're searching for
     * @param options: SearchOptions
     * @returns {Promise<GifsResult>}
     **/ GiphyFetch.prototype.search = function(term, options) {
        if (options === void 0) options = {};
        var q = options.channel ? "@".concat(options.channel, " ").concat(term) : term;
        var excludeDynamicResults;
        if (options.type === "text") excludeDynamicResults = true;
        var qsParams = this.getQS(__assign(__assign({
            rating: "pg-13"
        }, options), {
            q: q,
            excludeDynamicResults: excludeDynamicResults
        }));
        return (0, _requestDefault.default)("".concat(getType(options), "/search?").concat(qsParams), {
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    /**
     * Get a list of subcategories
     * @param {string} category
     * @param {SubcategoriesOptions} options
     * @returns {Promise<CategoriesResult>}
     */ GiphyFetch.prototype.subcategories = function(category, options) {
        return (0, _requestDefault.default)("gifs/categories/".concat(category, "?").concat(this.getQS(options)));
    };
    /**
     * Get trending gifs
     *
     * @param {TrendingOptions} options
     * @returns {Promise<GifsResult>}
     */ GiphyFetch.prototype.trending = function(options) {
        if (options === void 0) options = {};
        return (0, _requestDefault.default)("".concat(getType(options), "/trending?").concat(this.getQS(__assign({
            rating: "pg-13"
        }, options))), {
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    /**
     * Get a random gif
     * @param {RandomOptions} options
     * @returns {Promise<GifResult>}
     **/ GiphyFetch.prototype.random = function(options) {
        return (0, _requestDefault.default)("".concat(getType(options), "/random?").concat(this.getQS(__assign({
            rating: "pg-13"
        }, options))), {
            noCache: true,
            normalizer: (0, _gif.normalizeGif)
        });
    };
    /**
     * Get related gifs by a id
     * @param {string} id
     * @param {SubcategoriesOptions} options
     * @returns {Promise<GifsResult>}
     **/ GiphyFetch.prototype.related = function(id, options) {
        return (0, _requestDefault.default)("".concat((options === null || options === void 0 ? void 0 : options.type) === "stickers" ? "stickers" : "gifs", "/related?").concat(this.getQS(__assign({
            gif_id: id,
            rating: "pg-13"
        }, options))), {
            normalizer: (0, _gif.normalizeGifs)
        });
    };
    /**
     * Search for channels based on a term
     * @param {string} term
     * @param options: SearchOptions
     * @returns {Promise<ChannelsResult>}
     **/ GiphyFetch.prototype.channels = function(term, options) {
        if (options === void 0) options = {};
        return (0, _requestDefault.default)("channels/search?".concat(this.getQS(__assign({
            q: term,
            rating: "pg-13"
        }, options))));
    };
    return GiphyFetch;
}();
exports.default = GiphyFetch;

},{"@giphy/js-util":"lEFUV","qs":"3KnnP","./normalize/gif":"18rQu","./request":"5bjjQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KnnP":[function(require,module,exports) {
"use strict";
var stringify = require("a472ccaa2f2351e9");
var parse = require("7ffa4249597bf32b");
var formats = require("454df9476704f887");
module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"a472ccaa2f2351e9":"c65e4","7ffa4249597bf32b":"4TH1Q","454df9476704f887":"4FjOV"}],"c65e4":[function(require,module,exports) {
"use strict";
var getSideChannel = require("6246bbb805756d41");
var utils = require("44263cc7b702ebf");
var formats = require("929f8531a94a537c");
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats["default"];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get(sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && isArray(obj)) obj = utils.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = utils.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if (isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = formats["default"];
    if (typeof opts.format !== "undefined") {
        if (!has.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = formats.formatters[format];
    var filter = defaults.filter;
    if (typeof opts.filter === "function" || isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = getSideChannel();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

},{"6246bbb805756d41":"kTEaB","44263cc7b702ebf":"3YhBn","929f8531a94a537c":"4FjOV"}],"kTEaB":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("7911ec51a2dc9f3e");
var callBound = require("125062ab9035288f");
var inspect = require("9f4f5a92d8c6543");
var $TypeError = GetIntrinsic("%TypeError%");
var $WeakMap = GetIntrinsic("%WeakMap%", true);
var $Map = GetIntrinsic("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var listGet = function(objects, key) {
    var node = listGetNode(objects, key);
    return node && node.value;
};
var listSet = function(objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var listHas = function(objects, key) {
    return !!listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
        },
        get: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapGet($wm, key);
            } else if ($Map) {
                if ($m) return $mapGet($m, key);
            } else {
                if ($o) return listGet($o, key);
            }
        },
        has: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapHas($wm, key);
            } else if ($Map) {
                if ($m) return $mapHas($m, key);
            } else {
                if ($o) return listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $WeakMap();
                $weakMapSet($wm, key, value);
            } else if ($Map) {
                if (!$m) $m = new $Map();
                $mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                listSet($o, key, value);
            }
        }
    };
    return channel;
};

},{"7911ec51a2dc9f3e":"igBhj","125062ab9035288f":"eK6wT","9f4f5a92d8c6543":"87sBP"}],"igBhj":[function(require,module,exports) {
"use strict";
var undefined;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var hasProto = require("23730654306aa64c")();
var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("b03d0058935d00bf");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"1f00f712d594ccf":"7Qiml","23730654306aa64c":"bIcqy","7c5e688e48cd07b0":"42Rnv","b03d0058935d00bf":"654Bi"}],"7Qiml":[function(require,module,exports) {
"use strict";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"8apFc"}],"8apFc":[function(require,module,exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"bIcqy":[function(require,module,exports) {
"use strict";
var test = {
    foo: {}
};
var $Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: test
    }).foo === test.foo && !(({
        __proto__: null
    }) instanceof $Object);
};

},{}],"42Rnv":[function(require,module,exports) {
"use strict";
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"g2Nry"}],"g2Nry":[function(require,module,exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.call(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat(slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"654Bi":[function(require,module,exports) {
"use strict";
var bind = require("ec4f1e1d3f29fa3e");
module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"ec4f1e1d3f29fa3e":"42Rnv"}],"eK6wT":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"igBhj","266fc50410cfc4a":"8iKie"}],"8iKie":[function(require,module,exports) {
"use strict";
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var $apply = GetIntrinsic("%Function.prototype.apply%");
var $call = GetIntrinsic("%Function.prototype.call%");
var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
var $max = GetIntrinsic("%Math.max%");
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $reflectApply(bind, $call, arguments);
    if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $defineProperty(func, "length", {
            value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, "apply", {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"42Rnv","68d2ad3775278f43":"igBhj"}],"87sBP":[function(require,module,exports) {
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return isArray(obj) ? "[Array]" : "[Object]";
    var indent = getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if (indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return "[" + indentedJoin(xs, indent) + "]";
        return "[ " + $join.call(xs, ", ") + " ]";
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf("WeakMap");
    if (isWeakSet(obj)) return weakCollectionOf("WeakSet");
    if (isWeakRef(obj)) return weakCollectionOf("WeakRef");
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + indentedJoin(ys, indent) + "}";
        return tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, "&quot;");
}
function isArray(obj) {
    return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== "object") return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== "object") return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== "object") return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== "object") return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== "object") return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, "single", opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return "Object(" + str + ")";
}
function weakCollectionOf(type) {
    return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof gOPS === "function" ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"13Pcp"}],"13Pcp":[function(require,module,exports) {
"use strict";

},{}],"3YhBn":[function(require,module,exports) {
"use strict";
var formats = require("7adf3674f81a2c87");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if (isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
    if (isArray(target) && isArray(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    compactQueue(queue);
    return value;
};
var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b) {
    return [].concat(a, b);
};
var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"7adf3674f81a2c87":"4FjOV"}],"4FjOV":[function(require,module,exports) {
"use strict";
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],"4TH1Q":[function(require,module,exports) {
"use strict";
var utils = require("e76649c95dd0e736");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) charset = "utf-8";
            else if (parts[i] === isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
            val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = isArray(val) ? [
            val
        ] : val;
        if (has.call(obj, key)) obj[key] = utils.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = utils.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return utils.compact(obj);
};

},{"e76649c95dd0e736":"3YhBn"}],"18rQu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BOOL_PROPS", ()=>BOOL_PROPS);
parcelHelpers.export(exports, "USER_BOOL_PROPS", ()=>USER_BOOL_PROPS);
parcelHelpers.export(exports, "normalizeGif", ()=>normalizeGif);
parcelHelpers.export(exports, "normalizeGifs", ()=>normalizeGifs);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var BOOL_PROPS = [
    "is_anonymous",
    "is_community",
    "is_featured",
    "is_hidden",
    "is_indexable",
    "is_preserve_size",
    "is_realtime",
    "is_removed",
    "is_sticker",
    "is_dynamic"
];
var USER_BOOL_PROPS = [
    "suppress_chrome",
    "is_public",
    "is_verified"
];
var makeBool = function(obj) {
    return function(prop) {
        return obj[prop] = !!obj[prop];
    };
};
// tags sometimes are objects that have a text prop, sometimes they're strings
var getTag = function(tag) {
    return typeof tag === "string" ? tag : tag.text;
};
var normalize = function(gif) {
    var newGif = __assign({}, gif);
    newGif.id = String(newGif.id);
    newGif.tags = (newGif.tags || []).map(getTag);
    BOOL_PROPS.forEach(makeBool(newGif));
    Object.keys(newGif.images || {}).forEach(function(name) {
        var img = newGif.images[name];
        img.width = parseInt(img.width);
        img.height = parseInt(img.height);
    });
    var user = newGif.user;
    if (user) {
        var newUser = __assign({}, user);
        USER_BOOL_PROPS.forEach(makeBool(newUser));
        newGif.user = newUser;
    }
    return newGif;
};
var normalizeGif = function(result) {
    result.data = normalize(result.data);
    return result;
};
var normalizeGifs = function(result) {
    result.data = result.data.map(function(gif) {
        return normalize(gif);
    });
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bjjQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_PREFIX", ()=>ERROR_PREFIX);
parcelHelpers.export(exports, "DEFAULT_ERROR", ()=>DEFAULT_ERROR);
var _constants = require("./constants");
var _fetchError = require("./fetch-error");
var _fetchErrorDefault = parcelHelpers.interopDefault(_fetchError);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var ERROR_PREFIX = "@giphy/js-fetch-api: ";
var DEFAULT_ERROR = "Error fetching";
var identity = function(i) {
    return i;
};
var requestMap = {};
var maxLife = 60000; // clear memory cache every minute
var errorMaxLife = 6000; // clear error memory cache after a second
var purgeCache = function() {
    var now = Date.now();
    Object.keys(requestMap).forEach(function(key) {
        var ttl = requestMap[key].isError ? errorMaxLife : maxLife;
        if (now - requestMap[key].ts >= ttl) delete requestMap[key];
    });
};
function request(url, options) {
    var _this = this;
    if (options === void 0) options = {};
    var _a = options.apiVersion, apiVersion = _a === void 0 ? 1 : _a, _b = options.noCache, noCache = _b === void 0 ? false : _b, _c = options.normalizer, normalizer = _c === void 0 ? identity : _c;
    var serverUrl_ = (0, _constants.serverUrl).replace(/\/v\d+\/$/, "/v".concat(apiVersion, "/"));
    purgeCache();
    if (!requestMap[url] || noCache) {
        var fullUrl_1 = "".concat(serverUrl_).concat(url);
        var makeRequest = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var fetchError, response, result, message, result, _1, unexpectedError_1;
                var _a;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                9,
                                ,
                                10
                            ]);
                            return [
                                4 /*yield*/ ,
                                fetch(fullUrl_1, {
                                    method: "get"
                                })
                            ];
                        case 1:
                            response = _b.sent();
                            if (!response.ok) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 2:
                            result = _b.sent();
                            // no response id is an indiication of a synthetic response
                            if (!((_a = result.meta) === null || _a === void 0 ? void 0 : _a.response_id)) throw {
                                message: "synthetic response"
                            };
                            else // if everything is successful, we return here, otherwise an error will be thrown
                            return [
                                2 /*return*/ ,
                                normalizer(result)
                            ];
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 3:
                            message = DEFAULT_ERROR;
                            _b.label = 4;
                        case 4:
                            _b.trys.push([
                                4,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 5:
                            result = _b.sent();
                            if (result.message) message = result.message;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 6:
                            _1 = _b.sent();
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            if (requestMap[url]) // we got a specific error,
                            // normally, you'd want to not fetch this again,
                            // but the api goes down and sends 400s, so allow a refetch after errorMaxLife
                            requestMap[url].isError = true;
                            // we got an error response, throw with the message in the response body json
                            fetchError = new (0, _fetchErrorDefault.default)("".concat(ERROR_PREFIX).concat(message), fullUrl_1, response.status, response.statusText);
                            _b.label = 8;
                        case 8:
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case 9:
                            unexpectedError_1 = _b.sent();
                            fetchError = new (0, _fetchErrorDefault.default)(unexpectedError_1.message, fullUrl_1);
                            // if the request fails with an unspecfied error,
                            // the user can request again after the error timeout
                            if (requestMap[url]) requestMap[url].isError = true;
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case 10:
                            throw fetchError;
                    }
                });
            });
        };
        requestMap[url] = {
            request: makeRequest(),
            ts: Date.now()
        };
    }
    return requestMap[url].request;
}
exports.default = request;

},{"./constants":"jgLnO","./fetch-error":"ehR0g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgLnO":[function(require,module,exports) {
/* istanbul ignore next */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serverUrl", ()=>serverUrl);
parcelHelpers.export(exports, "setServerUrl", ()=>setServerUrl);
var global = arguments[3];
var gl = (typeof window !== "undefined" ? window : global) || {};
var serverUrl = gl.GIPHY_API_URL || "https://api.giphy.com/v1/";
var setServerUrl = function(url) {
    serverUrl = url;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ehR0g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var FetchError = /** @class */ function(_super) {
    __extends(FetchError, _super);
    function FetchError(message, url, status, statusText) {
        if (status === void 0) status = 0;
        if (statusText === void 0) statusText = "";
        var _this = _super.call(this, message) || this;
        _this.url = url;
        _this.status = status;
        _this.statusText = statusText;
        return _this;
    }
    return FetchError;
}(Error);
exports.default = FetchError;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"87qnT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Jmq6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gifPaginator", ()=>gifPaginator);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var gifPaginator = function(fetchGifs, initialGifs) {
    if (initialGifs === void 0) initialGifs = [];
    var gifs = __spreadArray([], initialGifs, true);
    // for deduping
    var gifIds = initialGifs.map(function(g) {
        return g.id;
    });
    var offset = initialGifs.length;
    var isDoneFetching = false;
    return function() {
        return __awaiter(void 0, void 0, void 0, function() {
            var result, pagination, newGifs;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (isDoneFetching) return [
                            2 /*return*/ ,
                            gifs
                        ];
                        return [
                            4 /*yield*/ ,
                            fetchGifs(offset)
                        ];
                    case 1:
                        result = _a.sent();
                        pagination = result.pagination, newGifs = result.data;
                        offset = pagination.count + pagination.offset;
                        isDoneFetching = offset === pagination.total_count;
                        newGifs.forEach(function(gif) {
                            var id = gif.id;
                            if (!gifIds.includes(id)) {
                                // add gifs and gifIds
                                gifs.push(gif);
                                gifIds.push(id);
                            }
                        });
                        return [
                            2 /*return*/ ,
                            __spreadArray([], gifs, true)
                        ];
                }
            });
        });
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98BXO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dTC97":[function(require,module,exports) {
module.exports = JSON.parse('{"scripts":{"clean":"rm -rf ./dist","dev":"parcel public/test.html","docs":"typedoc src/index.ts","build":"tsc && npm run build:esm","build:esm":"tsc -p ./tsconfig-esm.json","prepublish":"npm run clean && npm run build","test":"run -T jest --config ./jestconfig.js","test:watch":"run -T jest --config ./jestconfig.js --watchAll"},"name":"@giphy/js-fetch-api","version":"4.9.3","main":"dist/index.js","description":"Javascript API to fetch gifs and stickers from the GIPHY API.","homepage":"https://github.com/Giphy/giphy-js/tree/master/packages/fetch-api","types":"dist/index.d.ts","module":"esm/index.js","sideEffects":false,"exports":{".":{"types":"./dist/index.d.ts","import":"./esm/index.js","require":"./dist/index.js"},"./package.json":"./package.json"},"files":["dist/","esm/","src/**/*"],"license":"MIT","publishConfig":{"access":"public"},"dependencies":{"@giphy/js-types":"*","@giphy/js-util":"*","qs":"^6.9.4"},"devDependencies":{"@types/qs":"^6.9.4","jest-fetch-mock":"^3.0.3","parcel-bundler":"latest","typedoc":"^0.20.36","typedoc-thunder-theme":"^0.0.2","typescript":"^5.0.4"}}');

},{}],"awUBr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "injectGlobal", ()=>injectGlobal);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "sheet", ()=>sheet);
var _cache = require("@emotion/cache");
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
var _emotionCssCreateInstanceEsmJs = require("../create-instance/dist/emotion-css-create-instance.esm.js");
var _emotionCssCreateInstanceEsmJsDefault = parcelHelpers.interopDefault(_emotionCssCreateInstanceEsmJs);
var _createEmotion = (0, _emotionCssCreateInstanceEsmJsDefault.default)({
    key: "css"
}), flush = _createEmotion.flush, hydrate = _createEmotion.hydrate, cx = _createEmotion.cx, merge = _createEmotion.merge, getRegisteredStyles = _createEmotion.getRegisteredStyles, injectGlobal = _createEmotion.injectGlobal, keyframes = _createEmotion.keyframes, css = _createEmotion.css, sheet = _createEmotion.sheet, cache = _createEmotion.cache;

},{"@emotion/cache":"dJbf5","@emotion/serialize":"2Iv9c","@emotion/utils":"firjl","../create-instance/dist/emotion-css-create-instance.esm.js":"bmBhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJbf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + "box-$1$2" + (0, _stylis.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-item-" + (0, _stylis.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-line-pack" + (0, _stylis.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + "box-" + (0, _stylis.replace)(value, "-grow", "") + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, "$1" + (0, _stylis.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + "$1"), /(image-set)/, (0, _stylis.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + "box-pack:$3" + (0, _stylis.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, _stylis.WEBKIT) + "$2-$3" + "$1" + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, "stretch") ? prefix((0, _stylis.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ":", ":" + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, _stylis.WEBKIT) + "$2$3" + "$1" + (0, _stylis.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, "@", "@" + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"8lIuE","stylis":"lfeQC","@emotion/weak-memoize":"9scve","@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lIuE":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfeQC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9scve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMybP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Iv9c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"2ma2h","@emotion/unitless":"dfdEh","@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ma2h":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfdEh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"firjl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmBhN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
function insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion(options) {
    var cache = (0, _cacheDefault.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered, undefined);
        (0, _utils.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return merge(cache.registered, css, classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, _utils.getRegisteredStyles).bind(null, cache.registered),
        merge: merge.bind(null, cache.registered, css)
    };
};
var classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
exports.default = createEmotion;

},{"@emotion/cache":"dJbf5","@emotion/serialize":"2Iv9c","@emotion/utils":"firjl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbogy":[function(require,module,exports) {
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "throttle", ()=>throttle);
function throttle(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== "boolean") {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */ function debounce(delay, atBegin, callback) {
    return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3eCpt":[function(require,module,exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
var preact_1 = require("e68c34f4a525cbc7");
var Observer = /** @class */ function(_super) {
    __extends(Observer, _super);
    function Observer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.container = null;
        return _this;
    }
    Observer.prototype.componentDidMount = function() {
        var _this = this;
        this.io = new IntersectionObserver(function(_a) {
            var entry = _a[0];
            _this.setState({
                isVisible: entry.isIntersecting
            });
            var onVisibleChange = _this.props.onVisibleChange;
            if (onVisibleChange) onVisibleChange(entry.isIntersecting);
        });
        this.io.observe(this.container);
    };
    Observer.prototype.componentWillUnmount = function() {
        if (this.io) this.io.disconnect();
    };
    Observer.prototype.render = function(_a, _b) {
        var _this = this;
        var children = _a.children, className = _a.className;
        var isVisible = _b.isVisible;
        var kids = Array.isArray(children) ? children : [
            children
        ];
        return (0, preact_1.h)("div", {
            ref: function(div) {
                return _this.container = div;
            },
            className: className
        }, kids.map(function(child) {
            return child ? (0, preact_1.cloneElement)(child, {
                isVisible: isVisible
            }) : null;
        }));
    };
    return Observer;
}(preact_1.Component);
exports.default = Observer;

},{"e68c34f4a525cbc7":"hvsRZ"}],"63QOc":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColor = exports.GRID_COLORS = void 0;
var js_brand_1 = require("6ab945da2e020b75");
var js_util_1 = require("17aaf8281f0f0ca6");
var css_1 = require("dd3b601f0d97e873");
var preact_1 = require("65d2f9ef6d660261");
var hooks_1 = require("ecef5e7db4b088fe");
var pingback = __importStar(require("b61aaede2b2d7f67"));
var overlay_1 = __importDefault(require("a0cb23af62f29752"));
var verified_badge_1 = __importDefault(require("4f9de48a8e5f296c"));
var pingback_context_manager_1 = require("66a44c7776702f3");
var gifCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    display: block;\n    &:focus {\n        outline: unset;\n    }\n    img {\n        display: block;\n    }\n    .",
    " {\n        g {\n            fill: white;\n        }\n    }\n"
], [
    "\n    display: block;\n    &:focus {\n        outline: unset;\n    }\n    img {\n        display: block;\n    }\n    .",
    " {\n        g {\n            fill: white;\n        }\n    }\n"
])), verified_badge_1.default.className);
exports.GRID_COLORS = [
    js_brand_1.giphyBlue,
    js_brand_1.giphyGreen,
    js_brand_1.giphyPurple,
    js_brand_1.giphyRed,
    js_brand_1.giphyYellow
];
var getColor = function() {
    return exports.GRID_COLORS[Math.round(Math.random() * (exports.GRID_COLORS.length - 1))];
};
exports.getColor = getColor;
var hoverTimeoutDelay = 200;
var Container = function(props) {
    return props.href ? (0, preact_1.h)("a", __assign({
        href: props.href
    }, props)) : (0, preact_1.h)("div", __assign({}, props));
};
function useMutableRef(initialValue) {
    var ref = (0, hooks_1.useState)({
        current: initialValue
    })[0];
    return ref;
}
var placeholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
var noop = function() {};
var Gif = function(_a) {
    var gif = _a.gif, width = _a.width, forcedHeight = _a.height, _b = _a.onGifRightClick, onGifRightClick = _b === void 0 ? noop : _b, className = _a.className, _c = _a.onGifClick, onGifClick = _c === void 0 ? noop : _c, _d = _a.onGifKeyPress, onGifKeyPress = _d === void 0 ? noop : _d, _e = _a.onGifSeen, onGifSeen = _e === void 0 ? noop : _e, _f = _a.onGifVisible, onGifVisible = _f === void 0 ? noop : _f, _g = _a.user, user = _g === void 0 ? {} : _g, backgroundColor = _a.backgroundColor, _h = _a.hideAttribution, hideAttribution = _h === void 0 ? false : _h, _j = _a.noLink, noLink = _j === void 0 ? false : _j, _k = _a.borderRadius, borderRadius = _k === void 0 ? 4 : _k, tabIndex = _a.tabIndex;
    // only fire seen once per gif id
    var _l = (0, hooks_1.useState)(false), hasFiredSeen = _l[0], setHasFiredSeen = _l[1];
    // classname to target animations on image load
    var _m = (0, hooks_1.useState)(""), loadedClassname = _m[0], setLoadedClassName = _m[1];
    // hovered is for the gif overlay
    var _o = (0, hooks_1.useState)(false), isHovered = _o[0], setHovered = _o[1];
    // only show the gif if it's on the screen
    var _p = (0, hooks_1.useState)(false), shouldShowMedia = _p[0], setShouldShowMedia = _p[1];
    // the background color shouldn't change unless it comes from a prop or we have a sticker
    var defaultBgColor = (0, hooks_1.useRef)((0, exports.getColor)());
    // the a tag the media is rendered into
    var container = (0, hooks_1.useRef)(null);
    // intersection observer with no threshold
    var showGifObserver = useMutableRef();
    // intersection observer with a threshold of 1 (full element is on screen)
    var fullGifObserver = useMutableRef();
    // fire hover pingback after this timeout
    var hoverTimeout = useMutableRef();
    // fire onseen ref (changes per gif, so need a ref)
    var sendOnSeen = (0, hooks_1.useRef)(noop);
    // custom pingback
    var attributes = (0, hooks_1.useContext)(pingback_context_manager_1.PingbackContext).attributes;
    var onMouseOver = function(e) {
        clearTimeout(hoverTimeout.current);
        setHovered(true);
        hoverTimeout.current = window.setTimeout(function() {
            pingback.onGifHover(gif, user === null || user === void 0 ? void 0 : user.id, e.target, attributes);
        }, hoverTimeoutDelay);
    };
    var onMouseLeave = function() {
        clearTimeout(hoverTimeout.current);
        setHovered(false);
    };
    var onClick = function(e) {
        // fire pingback
        pingback.onGifClick(gif, user === null || user === void 0 ? void 0 : user.id, e.target, attributes);
        onGifClick(gif, e);
    };
    var onKeyPress = function(e) {
        onGifKeyPress(gif, e);
    };
    // using a ref in case `gif` changes
    sendOnSeen.current = function(entry) {
        // flag so we don't observe any more
        setHasFiredSeen(true);
        js_util_1.Logger.debug("GIF ".concat(gif.id, " seen. ").concat(gif.title));
        // fire pingback
        pingback.onGifSeen(gif, user === null || user === void 0 ? void 0 : user.id, entry.boundingClientRect, attributes);
        // fire custom onGifSeen
        onGifSeen === null || onGifSeen === void 0 || onGifSeen(gif, entry.boundingClientRect);
        // disconnect
        if (fullGifObserver.current) fullGifObserver.current.disconnect();
    };
    var onImageLoad = function(e) {
        if (!fullGifObserver.current) fullGifObserver.current = new IntersectionObserver(function(_a) {
            var entry = _a[0];
            if (entry.isIntersecting) sendOnSeen.current(entry);
        }, {
            threshold: [
                0.99
            ]
        });
        if (!hasFiredSeen && container.current && fullGifObserver.current) // observe img for full gif view
        fullGifObserver.current.observe(container.current);
        onGifVisible(gif, e); // gif is visible, perhaps just partially
        setLoadedClassName(Gif.imgLoadedClassName);
    };
    (0, hooks_1.useEffect)(function() {
        if (fullGifObserver.current) fullGifObserver.current.disconnect();
        setHasFiredSeen(false);
    }, [
        gif.id
    ]);
    (0, hooks_1.useEffect)(function() {
        showGifObserver.current = new IntersectionObserver(function(_a) {
            var entry = _a[0];
            var isIntersecting = entry.isIntersecting;
            // show the gif if the container is on the screen
            setShouldShowMedia(isIntersecting);
            // remove the fullGifObserver if we go off the screen
            // we may have already disconnected if the hasFiredSeen happened
            if (!isIntersecting && fullGifObserver.current) fullGifObserver.current.disconnect();
        });
        showGifObserver.current.observe(container.current);
        return function() {
            if (showGifObserver.current) showGifObserver.current.disconnect();
            if (fullGifObserver.current) fullGifObserver.current.disconnect();
            if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
        };
    }, []);
    var height = forcedHeight || (0, js_util_1.getGifHeight)(gif, width);
    var bestRendition = (0, js_util_1.getBestRendition)(gif.images, width, height);
    var rendition = gif.images[bestRendition.renditionName];
    var background = backgroundColor || // <- specified background prop
    // sticker has black if no backgroundColor is specified
    (gif.is_sticker ? "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAABlBMVEUhIiIWFhYoSqvJAAAAGElEQVQY02MAAv7///8PWxqIPwDZw5UGABtgwz2xhFKxAAAAAElFTkSuQmCC') 0 0" : defaultBgColor.current);
    var borderRadiusCss = borderRadius ? (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject([
        "\n              border-radius: ",
        "px;\n              overflow: hidden;\n          "
    ], [
        "\n              border-radius: ",
        "px;\n              overflow: hidden;\n          "
    ])), borderRadius) : "";
    return (0, preact_1.h)(Container, {
        href: noLink ? undefined : gif.url,
        style: {
            width: width,
            height: height
        },
        className: (0, css_1.cx)(Gif.className, gifCss, borderRadiusCss, className),
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onContextMenu: function(e) {
            return onGifRightClick(gif, e);
        },
        onKeyPress: onKeyPress,
        tabIndex: tabIndex
    }, (0, preact_1.h)("div", {
        style: {
            width: width,
            height: height,
            position: "relative"
        },
        ref: container
    }, (0, preact_1.h)("picture", null, (0, preact_1.h)("source", {
        type: "image/webp",
        srcSet: shouldShowMedia ? rendition.webp : placeholder
    }), (0, preact_1.h)("img", {
        className: [
            Gif.imgClassName,
            loadedClassname
        ].join(" "),
        src: shouldShowMedia ? rendition.url : placeholder,
        style: {
            background: background
        },
        width: width,
        height: height,
        alt: (0, js_util_1.getAltText)(gif),
        onLoad: shouldShowMedia ? onImageLoad : function() {}
    })), shouldShowMedia ? (0, preact_1.h)("div", null, !hideAttribution && (0, preact_1.h)(overlay_1.default, {
        gif: gif,
        isHovered: isHovered
    })) : null));
};
Gif.className = "giphy-gif";
Gif.imgClassName = "giphy-gif-img";
Gif.imgLoadedClassName = "giphy-img-loaded";
exports.default = Gif;
var templateObject_1, templateObject_2;

},{"6ab945da2e020b75":"gyA2O","17aaf8281f0f0ca6":"lEFUV","dd3b601f0d97e873":"awUBr","65d2f9ef6d660261":"hvsRZ","ecef5e7db4b088fe":"2TRXI","b61aaede2b2d7f67":"8EHW2","a0cb23af62f29752":"eQN4r","4f9de48a8e5f296c":"95fyi","66a44c7776702f3":"g219r"}],"gyA2O":[function(require,module,exports) {
// src/colors.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFonts", ()=>addFonts);
parcelHelpers.export(exports, "css", ()=>classNames);
parcelHelpers.export(exports, "deleteColor", ()=>deleteColor);
parcelHelpers.export(exports, "dimColor", ()=>dimColor);
parcelHelpers.export(exports, "errorColor", ()=>errorColor);
parcelHelpers.export(exports, "facebookColor", ()=>facebookColor);
parcelHelpers.export(exports, "fontFamily", ()=>fontFamily);
parcelHelpers.export(exports, "fontSize", ()=>fontSize);
parcelHelpers.export(exports, "gifOverlayColor", ()=>gifOverlayColor);
parcelHelpers.export(exports, "giphyAqua", ()=>giphyAqua);
parcelHelpers.export(exports, "giphyBlack", ()=>giphyBlack);
parcelHelpers.export(exports, "giphyBlue", ()=>giphyBlue);
parcelHelpers.export(exports, "giphyCharcoal", ()=>giphyCharcoal);
parcelHelpers.export(exports, "giphyDarkCharcoal", ()=>giphyDarkCharcoal);
parcelHelpers.export(exports, "giphyDarkGrey", ()=>giphyDarkGrey);
parcelHelpers.export(exports, "giphyDarkestGrey", ()=>giphyDarkestGrey);
parcelHelpers.export(exports, "giphyGreen", ()=>giphyGreen);
parcelHelpers.export(exports, "giphyIndigo", ()=>giphyIndigo);
parcelHelpers.export(exports, "giphyLightBlue", ()=>giphyLightBlue);
parcelHelpers.export(exports, "giphyLightCharcoal", ()=>giphyLightCharcoal);
parcelHelpers.export(exports, "giphyLightGrey", ()=>giphyLightGrey);
parcelHelpers.export(exports, "giphyLightestGrey", ()=>giphyLightestGrey);
parcelHelpers.export(exports, "giphyPink", ()=>giphyPink);
parcelHelpers.export(exports, "giphyPurple", ()=>giphyPurple);
parcelHelpers.export(exports, "giphyRed", ()=>giphyRed);
parcelHelpers.export(exports, "giphyWhite", ()=>giphyWhite);
parcelHelpers.export(exports, "giphyWhiteSmoke", ()=>giphyWhiteSmoke);
parcelHelpers.export(exports, "giphyYellow", ()=>giphyYellow);
parcelHelpers.export(exports, "instagramColor", ()=>instagramColor);
parcelHelpers.export(exports, "loader", ()=>loader_default);
parcelHelpers.export(exports, "pinterestColor", ()=>pinterestColor);
parcelHelpers.export(exports, "primaryCTA", ()=>primaryCTA);
parcelHelpers.export(exports, "primaryCTADisabled", ()=>primaryCTADisabled);
parcelHelpers.export(exports, "redditColor", ()=>redditColor);
parcelHelpers.export(exports, "secondaryCTA", ()=>secondaryCTA);
parcelHelpers.export(exports, "smsColor", ()=>smsColor);
parcelHelpers.export(exports, "tumblrColor", ()=>tumblrColor);
parcelHelpers.export(exports, "twitterColor", ()=>twitterColor);
// src/loader.ts
var _emotion = require("emotion");
var giphyBlack = "#121212";
var giphyDarkestGrey = "#212121";
var giphyDarkGrey = "#2e2e2e";
var giphyDarkCharcoal = "#3e3e3e";
var giphyCharcoal = "#4a4a4a";
var giphyLightCharcoal = "#5c5c5c";
var giphyLightGrey = "#a6a6a6";
var giphyLightestGrey = "#d8d8d8";
var giphyWhiteSmoke = "#ececec";
var giphyWhite = "#ffffff";
var giphyBlue = "#00ccff";
var giphyGreen = "#00ff99";
var giphyPurple = "#9933ff";
var giphyRed = "#ff6666";
var giphyYellow = "#fff35c";
var giphyAqua = "#00e6cc";
var giphyLightBlue = "#3191ff";
var giphyIndigo = "#6157ff";
var giphyPink = "#e646b6";
var facebookColor = "#3894fc";
var twitterColor = "#00ccff";
var pinterestColor = "#e54cb5";
var tumblrColor = "#529ecc";
var instagramColor = "#c23c8d";
var redditColor = "#fc6669";
var smsColor = "#00ff99";
var errorColor = giphyRed;
var deleteColor = giphyRed;
var primaryCTA = giphyIndigo;
var primaryCTADisabled = "#241F74";
var secondaryCTA = giphyCharcoal;
var dimColor = `rgba(0, 0, 0, 0.8)`;
var gifOverlayColor = `rgba(0, 0, 0, 0.4)`;
var bouncer = (0, _emotion.keyframes)`
     to {
    transform: scale(1.75) translateY(-20px);
  }
`;
var loaderHeight = 37;
var loader = (0, _emotion.css)`
    display: flex;
    align-items: center;
    height: ${loaderHeight}px;
    padding-top: 15px;
    margin: 0 auto;
    text-align: center;
    justify-content: center;
    animation: pulse 0.8s ease-in-out 0s infinite alternate backwards;
    div {
        display: inline-block;
        height: 10px;
        width: 10px;
        margin: ${loaderHeight}px 10px 10px 10px;
        position: relative;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
        animation: ${bouncer} cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s infinite alternate;
        &:nth-child(5n + 1) {
            background: ${giphyGreen};
            animation-delay: 0;
        }
        &:nth-child(5n + 2) {
            background: ${giphyBlue};
            animation-delay: calc(0s + (0.1s * 1));
        }
        &:nth-child(5n + 3) {
            background: ${giphyPurple};
            animation-delay: calc(0s + (0.1s * 2));
        }
        &:nth-child(5n + 4) {
            background: ${giphyRed};
            animation-delay: calc(0s + (0.1s * 3));
        }
        &:nth-child(5n + 5) {
            background: ${giphyYellow};
            animation-delay: calc(0s + (0.1s * 4));
        }
    }
`;
var loader_default = loader;
var addFonts = ()=>(0, _emotion.injectGlobal)`
@font-face {
    font-family: 'interface';
    font-style: normal;
    font-weight: normal;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Rg.woff2') format('woff2'),
        url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Rg.woff') format('woff');
}

@font-face {
    font-family: 'interface';
    font-style: normal;
    font-weight: bold;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Bd.woff2') format('woff2'),
        url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Bd.woff') format('woff');
}
@font-face {
    font-family: 'interface';
    font-style: normal;
    font-weight: 900;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_XBd.woff') format('woff');
}
@font-face {
    font-family: 'nexablack'; 
    font-style: normal;
    font-weight: normal;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/nexa_black-webfont.woff2') format('woff2'),
        url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/nexa_black-webfont.woff') format('woff');
}
@font-face {
    font-family: 'SSStandard'; 
    font-style: normal;
    font-weight: normal;
    src:  url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/ss-standard.woff') format('woff');
}
@font-face {
    font-family: 'SSSocial'; 
    font-style: normal;
    font-weight: normal;
    src:  url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/ss-social.woff') format('woff');
}
`;
try {
    addFonts();
} catch (error) {
    addFonts();
}
var fontFamily = {
    title: "'nexablack', sans-serif",
    body: "interface, Helvetica Neue, helvetica, sans-serif;"
};
var fontSize = {
    titleSmall: "20px",
    title: "26px",
    titleLarge: "36px",
    subheader: "16px",
    subheaderSmall: "12px"
};
var sharedTitle = (0, _emotion.css)`
    font-family: ${fontFamily.title};
    -webkit-font-smoothing: antialiased;
`;
var title = (0, _emotion.cx)((0, _emotion.css)`
        font-size: ${fontSize.title};
    `, sharedTitle);
var titleLarge = (0, _emotion.cx)((0, _emotion.css)`
        font-size: ${fontSize.titleLarge};
    `, sharedTitle);
var titleSmall = (0, _emotion.cx)((0, _emotion.css)`
        font-size: ${fontSize.titleSmall};
    `, sharedTitle);
var sharedSubheader = (0, _emotion.css)`
    font-family: ${fontFamily.body};
    font-weight: bold;
    -webkit-font-smoothing: antialiased;
`;
var subheader = (0, _emotion.cx)((0, _emotion.css)`
        font-size: ${fontSize.subheader};
    `, sharedSubheader);
var subheaderSmall = (0, _emotion.cx)((0, _emotion.css)`
        font-size: ${fontSize.subheaderSmall};
    `, sharedSubheader);
var sectionHeader = (0, _emotion.css)`
    font-family: ${fontFamily.body};
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    -webkit-font-smoothing: antialiased;
`;
var classNames = {
    sectionHeader,
    subheaderSmall,
    subheader,
    titleLarge,
    titleSmall,
    title
};

},{"emotion":"1BAMo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BAMo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "injectGlobal", ()=>injectGlobal);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "sheet", ()=>sheet);
var _createEmotion = require("create-emotion");
var _createEmotionDefault = parcelHelpers.interopDefault(_createEmotion);
var _createEmotion1 = (0, _createEmotionDefault.default)(), flush = _createEmotion1.flush, hydrate = _createEmotion1.hydrate, cx = _createEmotion1.cx, merge = _createEmotion1.merge, getRegisteredStyles = _createEmotion1.getRegisteredStyles, injectGlobal = _createEmotion1.injectGlobal, keyframes = _createEmotion1.keyframes, css = _createEmotion1.css, sheet = _createEmotion1.sheet, cache = _createEmotion1.cache;

},{"create-emotion":"i5Qmo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i5Qmo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
function insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion(options) {
    var cache = (0, _cacheDefault.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered, undefined);
        (0, _utils.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return merge(cache.registered, css, classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, _utils.getRegisteredStyles).bind(null, cache.registered),
        merge: merge.bind(null, cache.registered, css)
    };
};
var classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
exports.default = createEmotion;

},{"@emotion/cache":"501yi","@emotion/serialize":"2Hcly","@emotion/utils":"8BW0D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"501yi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sheet = require("@emotion/sheet");
var _stylis = require("@emotion/stylis");
var _stylisDefault = parcelHelpers.interopDefault(_stylis);
var _weakMemoize = require("@emotion/weak-memoize");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = "/*|*/";
var needle = delimiter + "}";
function toSheet(block) {
    if (block) Sheet.current.insert(block + "}");
}
var Sheet = {
    current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? delimiter : "");
            }
        case -2:
            content.split(needle).forEach(toSheet);
    }
};
var createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, _stylisDefault.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
exports.default = createCache;

},{"@emotion/sheet":"1ViYS","@emotion/stylis":"kkVJI","@emotion/weak-memoize":"j3LGf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ViYS":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkVJI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
exports.default = stylis_min;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3LGf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
exports.default = weakMemoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Hcly":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var shouldWarnAboutInterpolatingClassNameFromCss = true;
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"1yfeS","@emotion/unitless":"jlIoB","@emotion/memoize":"iDWxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1yfeS":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
exports.default = murmur2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlIoB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iDWxQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8BW0D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TRXI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useState", ()=>m);
parcelHelpers.export(exports, "useReducer", ()=>p);
parcelHelpers.export(exports, "useEffect", ()=>y);
parcelHelpers.export(exports, "useLayoutEffect", ()=>l);
parcelHelpers.export(exports, "useRef", ()=>h);
parcelHelpers.export(exports, "useImperativeHandle", ()=>s);
parcelHelpers.export(exports, "useMemo", ()=>_);
parcelHelpers.export(exports, "useCallback", ()=>A);
parcelHelpers.export(exports, "useContext", ()=>F);
parcelHelpers.export(exports, "useDebugValue", ()=>T);
parcelHelpers.export(exports, "useErrorBoundary", ()=>d);
var _preact = require("preact");
var t, u, r, o = 0, i = [], c = (0, _preact.options).__r, f = (0, _preact.options).diffed, e = (0, _preact.options).__c, a = (0, _preact.options).unmount;
function v(t, r) {
    (0, _preact.options).__h && (0, _preact.options).__h(u, t, o || r), o = 0;
    var i = u.__H || (u.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({}), i.__[t];
}
function m(n) {
    return o = 1, p(k, n);
}
function p(n, r, o) {
    var i = v(t++, 2);
    return i.t = n, i.__c || (i.__c = u, i.__ = [
        o ? o(r) : k(void 0, r),
        function(n) {
            var t = i.t(i.__[0], n);
            i.__[0] !== t && (i.__ = [
                t,
                i.__[1]
            ], i.__c.setState({}));
        }
    ]), i.__;
}
function y(r, o) {
    var i = v(t++, 3);
    !(0, _preact.options).__s && j(i.__H, o) && (i.__ = r, i.__H = o, u.__H.__h.push(i));
}
function l(r, o) {
    var i = v(t++, 4);
    !(0, _preact.options).__s && j(i.__H, o) && (i.__ = r, i.__H = o, u.__h.push(i));
}
function h(n) {
    return o = 5, _(function() {
        return {
            current: n
        };
    }, []);
}
function s(n, t, u) {
    o = 6, l(function() {
        "function" == typeof n ? n(t()) : n && (n.current = t());
    }, null == u ? u : u.concat(n));
}
function _(n, u) {
    var r = v(t++, 7);
    return j(r.__H, u) ? (r.__H = u, r.__h = n, r.__ = n()) : r.__;
}
function A(n, t) {
    return o = 8, _(function() {
        return n;
    }, t);
}
function F(n) {
    var r = u.context[n.__c], o = v(t++, 9);
    return o.__c = n, r ? (null == o.__ && (o.__ = !0, r.sub(u)), r.props.value) : n.__;
}
function T(t, u) {
    (0, _preact.options).useDebugValue && (0, _preact.options).useDebugValue(u ? u(t) : t);
}
function d(n) {
    var r = v(t++, 10), o = m();
    return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function(n) {
        r.__ && r.__(n), o[1](n);
    }), [
        o[0],
        function() {
            o[1](void 0);
        }
    ];
}
function q() {
    i.some(function(t) {
        if (t.__P) try {
            t.__H.__h.forEach(b), t.__H.__h.forEach(g), t.__H.__h = [];
        } catch (u) {
            return t.__H.__h = [], (0, _preact.options).__e(u, t.__v), !0;
        }
    }), i = [];
}
(0, _preact.options).__r = function(n) {
    c && c(n), t = 0;
    var r = (u = n.__c).__H;
    r && (r.__h.forEach(b), r.__h.forEach(g), r.__h = []);
}, (0, _preact.options).diffed = function(t) {
    f && f(t);
    var u = t.__c;
    u && u.__H && u.__H.__h.length && (1 !== i.push(u) && r === (0, _preact.options).requestAnimationFrame || ((r = (0, _preact.options).requestAnimationFrame) || function(n) {
        var t, u = function() {
            clearTimeout(r), x && cancelAnimationFrame(t), setTimeout(n);
        }, r = setTimeout(u, 100);
        x && (t = requestAnimationFrame(u));
    })(q));
}, (0, _preact.options).__c = function(t, u) {
    u.some(function(t) {
        try {
            t.__h.forEach(b), t.__h = t.__h.filter(function(n) {
                return !n.__ || g(n);
            });
        } catch (r) {
            u.some(function(n) {
                n.__h && (n.__h = []);
            }), u = [], (0, _preact.options).__e(r, t.__v);
        }
    }), e && e(t, u);
}, (0, _preact.options).unmount = function(t) {
    a && a(t);
    var u = t.__c;
    if (u && u.__H) try {
        u.__H.__.forEach(b);
    } catch (t) {
        (0, _preact.options).__e(t, u.__v);
    }
};
var x = "function" == typeof requestAnimationFrame;
function b(n) {
    "function" == typeof n.u && n.u();
}
function g(n) {
    n.u = n.__();
}
function j(n, t) {
    return !n || t.some(function(t, u) {
        return t !== n[u];
    });
}
function k(n, t) {
    return "function" == typeof t ? t(n) : t;
}

},{"preact":"hvsRZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8EHW2":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onGifHover = exports.onGifClick = exports.onGifSeen = void 0;
var js_analytics_1 = require("6b2edff8e02154ba");
var js_util_1 = require("770ea7dfec8f66e5");
var firePingback = function(actionType) {
    return function(gif, userId, target, attributes) {
        if (attributes === void 0) attributes = {};
        if (!gif.analytics_response_payload) return;
        (0, js_analytics_1.pingback)({
            userId: userId,
            actionType: actionType,
            attributes: __assign({
                position: JSON.stringify((0, js_util_1.getClientRect)(target))
            }, attributes),
            analyticsResponsePayload: gif.analytics_response_payload
        });
    };
};
// no target on this one
var onGifSeen = function(gif, userId, position, attributes) {
    if (attributes === void 0) attributes = {};
    if (!gif.analytics_response_payload) return;
    (0, js_analytics_1.pingback)({
        analyticsResponsePayload: gif.analytics_response_payload,
        userId: userId,
        actionType: "SEEN",
        attributes: __assign({
            position: JSON.stringify(position)
        }, attributes)
    });
};
exports.onGifSeen = onGifSeen;
exports.onGifClick = firePingback("CLICK");
exports.onGifHover = firePingback("HOVER");

},{"6b2edff8e02154ba":"hBsEL","770ea7dfec8f66e5":"lEFUV"}],"hBsEL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAttributes", ()=>merge_attributes_default);
parcelHelpers.export(exports, "pingback", ()=>pingback_default);
// src/merge-attributes.ts
var _jsUtil = require("@giphy/js-util");
var _throttleDebounce = require("throttle-debounce");
var global = arguments[3];
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var mergeAttribute = (attributes, newAttributes, key)=>{
    const result1 = (0, _jsUtil.pick)(attributes, [
        key
    ]);
    const result2 = (0, _jsUtil.pick)(newAttributes, [
        key
    ]);
    if (result1[key] && result2[key]) return __spreadValues(__spreadValues(__spreadValues({}, attributes), newAttributes), {
        [key]: result1[key] + ", " + result2[key]
    });
    return __spreadValues(__spreadValues({}, attributes), newAttributes);
};
var merge_attributes_default = mergeAttribute;
// src/global.ts
var global_default = (typeof window !== "undefined" ? window : global) || {};
var _a;
var environment = ((_a = global_default) == null ? void 0 : _a.GIPHY_PINGBACK_URL) || "https://pingback.giphy.com";
var pingBackUrl = `${environment}/v2/pingback?apikey=l0HlIwPWyBBUDAUgM`;
var sendPingback = (events)=>{
    const headers = (0, _jsUtil.getGiphySDKRequestHeaders)();
    headers == null || headers.set("Content-Type", "application/json");
    (0, _jsUtil.Logger).debug(`Pingback session`, events);
    if (!events.length) return new Promise((resolve)=>resolve());
    return fetch(pingBackUrl, {
        method: "POST",
        body: JSON.stringify({
            events
        }),
        headers
    }).catch((error)=>{
        (0, _jsUtil.Logger).warn(`pingbacks failing to post ${error}`);
    });
};
// src/pingback.ts
var queuedPingbackEvents = [];
global_default.giphyRandomId = (0, _jsUtil.getPingbackId)();
var loggedInUserId = "";
function sendPingbacks() {
    const sendEvents = [
        ...queuedPingbackEvents
    ];
    queuedPingbackEvents = [];
    sendPingback(sendEvents);
}
var debouncedPingbackEvent = (0, _throttleDebounce.debounce)(1e3, sendPingbacks);
var _a2, _b;
(_b = (_a2 = global_default).addEventListener) == null || _b.call(_a2, "beforeunload", sendPingbacks);
var pingback = ({ userId, eventType, actionType, attributes, queueEvents = true, analyticsResponsePayload })=>{
    loggedInUserId = userId ? String(userId) : loggedInUserId;
    const newEvent = {
        ts: Date.now(),
        attributes,
        action_type: actionType,
        user_id: (0, _jsUtil.getPingbackId)(),
        analytics_response_payload: analyticsResponsePayload
    };
    if (loggedInUserId) newEvent.logged_in_user_id = loggedInUserId;
    if (newEvent.analytics_response_payload) newEvent.analytics_response_payload = `${newEvent.analytics_response_payload}${(0, _jsUtil.Logger).ENABLED ? "&mode=verification" : ""}`;
    if (eventType) newEvent.event_type = eventType;
    queuedPingbackEvents.push(newEvent);
    queueEvents ? debouncedPingbackEvent() : sendPingbacks();
};
var pingback_default = pingback;

},{"@giphy/js-util":"lEFUV","throttle-debounce":"kbogy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eQN4r":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var css_1 = require("916358b4424b24c4");
var preact_1 = require("81ae9ae21e7e3ecf");
var hooks_1 = require("6d8a75140aea78a");
var _1 = __importDefault(require("287f648f61689f85"));
var backgroundCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));\n    cursor: default;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 75px;\n    pointer-events: none;\n"
], [
    "\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));\n    cursor: default;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 75px;\n    pointer-events: none;\n"
])));
var attributionCss = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject([
    "\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n"
], [
    "\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n"
])));
var containerCss = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject([
    "\n    transition: opacity 150ms ease-in;\n"
], [
    "\n    transition: opacity 150ms ease-in;\n"
])));
var AttributionOverlay = function(_a) {
    var gif = _a.gif, isHovered = _a.isHovered, onClick = _a.onClick;
    var hasHovered = (0, hooks_1.useRef)(isHovered);
    if (isHovered) // not rendering to avoid loading the avatar until hover
    hasHovered.current = true;
    return gif.user && hasHovered.current ? (0, preact_1.h)("div", {
        className: containerCss,
        style: {
            opacity: isHovered ? 1 : 0
        }
    }, (0, preact_1.h)("div", {
        className: backgroundCss
    }), (0, preact_1.h)(_1.default, {
        gif: gif,
        className: attributionCss,
        onClick: onClick
    })) : null;
};
exports.default = AttributionOverlay;
var templateObject_1, templateObject_2, templateObject_3;

},{"916358b4424b24c4":"awUBr","81ae9ae21e7e3ecf":"hvsRZ","6d8a75140aea78a":"2TRXI","287f648f61689f85":"lS8bA"}],"lS8bA":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var css_1 = require("2748bea6033bc834");
var preact_1 = require("9e67915f4b9d141c");
var avatar_1 = __importDefault(require("3e2872e8c00c774c"));
var verified_badge_1 = __importDefault(require("66ff24317b26a22c"));
var containerCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    display: flex;\n    align-items: center;\n    font-family: interface, helvetica, arial;\n"
], [
    "\n    display: flex;\n    align-items: center;\n    font-family: interface, helvetica, arial;\n"
])));
var avatarCss = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject([
    "\n    flex-shrink: 0;\n"
], [
    "\n    flex-shrink: 0;\n"
])));
var userName = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject([
    "\n    color: white;\n    font-size: 17px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-font-smoothing: antialiased;\n"
], [
    "\n    color: white;\n    font-size: 17px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-font-smoothing: antialiased;\n"
])));
var verifiedBadge = (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject([
    "\n    margin: 0 4px;\n    flex-shrink: 0;\n"
], [
    "\n    margin: 0 4px;\n    flex-shrink: 0;\n"
])));
var Attribution = function(_a) {
    var gif = _a.gif, className = _a.className, onClick = _a.onClick;
    var user = gif.user;
    if (!(user === null || user === void 0 ? void 0 : user.username) && !(user === null || user === void 0 ? void 0 : user.display_name)) return null;
    var display_name = user.display_name, username = user.username;
    return (0, preact_1.h)("div", {
        className: (0, css_1.cx)(containerCss, Attribution.className, className),
        onClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (onClick) onClick(gif);
            else {
                var url = user.profile_url;
                if (url) window.open(url, "_blank");
            }
        }
    }, (0, preact_1.h)(avatar_1.default, {
        user: user,
        className: avatarCss
    }), (0, preact_1.h)("div", {
        className: userName
    }, display_name || "@".concat(username)), user.is_verified ? (0, preact_1.h)(verified_badge_1.default, {
        size: 14,
        className: verifiedBadge
    }) : null);
};
Attribution.className = "giphy-attribution";
exports.default = Attribution;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

},{"2748bea6033bc834":"awUBr","9e67915f4b9d141c":"hvsRZ","3e2872e8c00c774c":"2qar8","66ff24317b26a22c":"95fyi"}],"2qar8":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var css_1 = require("6bbb034934507bef");
var preact_1 = require("9f20cb5485b8ffb2");
var hooks_1 = require("fd5fe49e9ea577c6");
var getSmallAvatar = function(avatar) {
    var _a, _b;
    if (!avatar) return "";
    var ext = (_b = (_a = avatar === null || avatar === void 0 ? void 0 : avatar.split(".")) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    return avatar.replace(".".concat(ext), "/80h.".concat(ext));
};
var avatarCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    object-fit: cover;\n    width: 32px;\n    height: 32px;\n    margin-right: 8px;\n"
], [
    "\n    object-fit: cover;\n    width: 32px;\n    height: 32px;\n    margin-right: 8px;\n"
])));
var Avatar = function(_a) {
    var user = _a.user, _b = _a.className, className = _b === void 0 ? "" : _b;
    var defaultAvatarId = (0, hooks_1.useRef)(Math.floor(Math.random() * 5) + 1);
    var url = user.avatar_url ? getSmallAvatar(user.avatar_url) : "https://media.giphy.com/avatars/default".concat(defaultAvatarId.current, ".gif");
    return (0, preact_1.h)("img", {
        src: url,
        className: (0, css_1.cx)(avatarCss, className)
    });
};
exports.default = Avatar;
var templateObject_1;

},{"6bbb034934507bef":"awUBr","9f20cb5485b8ffb2":"hvsRZ","fd5fe49e9ea577c6":"2TRXI"}],"95fyi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var css_1 = require("a50acfd086340eca");
var preact_1 = require("3804094356b82652");
var VerifiedBadge = function(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? 17 : _c, _d = _a.fill, fill = _d === void 0 ? "#15CDFF" : _d;
    return (0, preact_1.h)("svg", {
        className: (0, css_1.cx)(VerifiedBadge.className, className),
        height: size,
        width: "19px",
        viewBox: "0 0 19 17"
    }, (0, preact_1.h)("g", {
        transform: "translate(-532.000000, -466.000000)",
        fill: fill
    }, (0, preact_1.h)("g", {
        transform: "translate(141.000000, 235.000000)"
    }, (0, preact_1.h)("g", {
        transform: "translate(264.000000, 0.000000)"
    }, (0, preact_1.h)("g", {
        transform: "translate(10.000000, 224.000000)"
    }, (0, preact_1.h)("g", {
        transform: "translate(114.000000, 2.500000)"
    }, (0, preact_1.h)("path", {
        d: "M15.112432,4.80769231 L16.8814194,6.87556817 L19.4157673,7.90116318 L19.6184416,10.6028916 L21.0594951,12.9065042 L19.6184416,15.2101168 L19.4157673,17.9118452 L16.8814194,18.9374402 L15.112432,21.0053161 L12.4528245,20.3611511 L9.79321699,21.0053161 L8.02422954,18.9374402 L5.48988167,17.9118452 L5.28720734,15.2101168 L3.84615385,12.9065042 L5.28720734,10.6028916 L5.48988167,7.90116318 L8.02422954,6.87556817 L9.79321699,4.80769231 L12.4528245,5.4518573 L15.112432,4.80769231 Z M17.8163503,10.8991009 L15.9282384,9.01098901 L11.5681538,13.3696923 L9.68115218,11.4818515 L7.81302031,13.3499833 L9.7011322,15.2380952 L11.5892441,17.1262071 L17.8163503,10.8991009 Z"
    })))))));
};
VerifiedBadge.className = "giphy-verified-badge";
exports.default = VerifiedBadge;

},{"a50acfd086340eca":"awUBr","3804094356b82652":"hvsRZ"}],"g219r":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PingbackContext = void 0;
var js_analytics_1 = require("cc23888f2dfd97fa");
var preact_1 = require("e51c28f84bb22822");
var hooks_1 = require("ac39e239f0d22aad");
exports.PingbackContext = (0, preact_1.createContext)({});
var PingbackContextManager = function(_a) {
    var attributes = _a.attributes, children = _a.children;
    var _b = (0, hooks_1.useContext)(exports.PingbackContext).attributes, parentAttributes = _b === void 0 ? {} : _b;
    return (0, preact_1.h)(exports.PingbackContext.Provider, {
        value: {
            attributes: (0, js_analytics_1.mergeAttributes)(parentAttributes, attributes, "layout_type")
        }
    }, children);
};
exports.default = PingbackContextManager;

},{"cc23888f2dfd97fa":"hBsEL","e51c28f84bb22822":"hvsRZ","ac39e239f0d22aad":"2TRXI"}],"9WoOk":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var js_fetch_api_1 = require("3b085c13ee262042");
var bricks_js_1 = __importDefault(require("fd33f62ac5aa3749"));
var css_1 = require("662de7a1bbb4be15");
var preact_1 = require("d4066f16a566875f");
var throttle_debounce_1 = require("b94e3c21c97ebe5d");
var observer_1 = __importDefault(require("8d92cce882f0a23a"));
var fetch_error_1 = __importDefault(require("5f916d80b5ff18fc"));
var gif_1 = __importDefault(require("36892a48fd4b231b"));
var loader_1 = __importDefault(require("b6f635b9c48733e7"));
var pingback_context_manager_1 = __importDefault(require("4c9fdf8ab3c3b548"));
var loaderHiddenCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    opacity: 0;\n"
], [
    "\n    opacity: 0;\n"
])));
var defaultProps = Object.freeze({
    gutter: 6,
    user: {}
});
var initialState = Object.freeze({
    isFetching: false,
    isError: false,
    numberOfGifs: 0,
    gifWidth: 0,
    gifs: [],
    isLoaderVisible: true,
    isDoneFetching: false
});
var Grid = /** @class */ function(_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.el = null;
        _this.paginator = (0, js_fetch_api_1.gifPaginator)(_this.props.fetchGifs);
        _this.onLoaderVisible = function(isVisible) {
            _this.setState({
                isLoaderVisible: isVisible
            }, _this.onFetch);
        };
        _this.fetchGifs = (0, throttle_debounce_1.debounce)(Grid.fetchDebounce, function(prefetchCount) {
            return __awaiter(_this, void 0, void 0, function() {
                var gifs, error_1, onGifsFetchError, onGifsFetched;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.paginator()
                            ];
                        case 1:
                            gifs = _a.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            error_1 = _a.sent();
                            this.setState({
                                isFetching: false,
                                isError: true
                            });
                            onGifsFetchError = this.props.onGifsFetchError;
                            if (onGifsFetchError) onGifsFetchError(error_1);
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 3:
                            if (gifs) {
                                // if we've just fetched and we don't have
                                // any more gifs, we're done fetching
                                if (prefetchCount === gifs.length) this.setState({
                                    isDoneFetching: true
                                });
                                else {
                                    this.setState({
                                        gifs: gifs,
                                        isFetching: false
                                    });
                                    onGifsFetched = this.props.onGifsFetched;
                                    if (onGifsFetched) onGifsFetched(gifs);
                                    this.onFetch();
                                }
                            }
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        _this.onFetch = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var _a, isFetching, isLoaderVisible, gifs;
                return __generator(this, function(_b) {
                    _a = this.state, isFetching = _a.isFetching, isLoaderVisible = _a.isLoaderVisible, gifs = _a.gifs;
                    if (!isFetching && isLoaderVisible) {
                        this.setState({
                            isFetching: true,
                            isError: false
                        });
                        this.fetchGifs(gifs.length);
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        return _this;
    }
    Grid.getDerivedStateFromProps = function(_a, prevState) {
        var columns = _a.columns, gutter = _a.gutter, width = _a.width;
        var gutterOffset = gutter * (columns - 1);
        var gifWidth = Math.floor((width - gutterOffset) / columns);
        if (prevState.gifWidth !== gifWidth) return {
            gifWidth: gifWidth
        };
        return {};
    };
    Grid.prototype.setBricks = function() {
        var _a = this.props, columns = _a.columns, gutter = _a.gutter;
        // bricks
        this.bricks = (0, bricks_js_1.default)({
            container: this.el,
            packed: "data-packed-".concat(columns),
            sizes: [
                {
                    columns: columns,
                    gutter: gutter
                }
            ]
        });
    };
    Grid.prototype.componentDidMount = function() {
        this.setBricks();
        this.onFetch();
    };
    Grid.prototype.componentDidUpdate = function(prevProps, prevState) {
        var gifs = this.state.gifs;
        var gifWidth = this.state.gifWidth;
        var numberOfOldGifs = prevState.gifs.length;
        var numberOfNewGifs = gifs.length;
        if (prevState.gifWidth !== gifWidth && numberOfOldGifs > 0) {
            var columns = this.props.columns;
            if (columns !== prevProps.columns) this.setBricks();
            this.bricks.pack();
        }
        if (prevState.gifs !== gifs) {
            if (numberOfNewGifs > numberOfOldGifs && numberOfOldGifs > 0) // we just added new gifs
            this.bricks.update();
            else // we changed existing gifs or removed a gif
            this.bricks.pack();
        }
    };
    Grid.prototype.render = function(_a, _b) {
        var _this = this;
        var onGifVisible = _a.onGifVisible, onGifRightClick = _a.onGifRightClick, _c = _a.className, className = _c === void 0 ? Grid.className : _c, onGifClick = _a.onGifClick, onGifHover = _a.onGifHover, onGifKeyPress = _a.onGifKeyPress, onGifSeen = _a.onGifSeen, user = _a.user, noResultsMessage = _a.noResultsMessage, hideAttribution = _a.hideAttribution, noLink = _a.noLink, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, borderRadius = _a.borderRadius;
        var gifWidth = _b.gifWidth, gifs = _b.gifs, isError = _b.isError, isDoneFetching = _b.isDoneFetching;
        var showLoader = !isDoneFetching;
        var isFirstLoad = gifs.length === 0;
        return (0, preact_1.h)(pingback_context_manager_1.default, {
            attributes: {
                layout_type: "GRID"
            }
        }, (0, preact_1.h)("div", {
            class: className
        }, (0, preact_1.h)("div", {
            ref: function(c) {
                return _this.el = c;
            }
        }, gifs.map(function(gif) {
            return (0, preact_1.h)(gif_1.default, {
                gif: gif,
                key: gif.id,
                tabIndex: tabIndex,
                width: gifWidth,
                onGifClick: onGifClick,
                onGifHover: onGifHover,
                onGifKeyPress: onGifKeyPress,
                onGifSeen: onGifSeen,
                onGifVisible: onGifVisible,
                onGifRightClick: onGifRightClick,
                user: user,
                hideAttribution: hideAttribution,
                noLink: noLink,
                borderRadius: borderRadius
            });
        }), !showLoader && gifs.length === 0 && noResultsMessage), isError ? (0, preact_1.h)(fetch_error_1.default, {
            onClick: this.onFetch
        }) : showLoader && (0, preact_1.h)(observer_1.default, {
            onVisibleChange: this.onLoaderVisible
        }, (0, preact_1.h)(loader_1.default, {
            className: (0, css_1.cx)(Grid.loaderClassName, isFirstLoad ? loaderHiddenCss : "")
        }))));
    };
    Grid.className = "giphy-grid";
    Grid.loaderClassName = "giphy-loader";
    Grid.defaultProps = defaultProps;
    Grid.fetchDebounce = 250;
    return Grid;
}(preact_1.Component);
exports.default = Grid;
var templateObject_1;

},{"3b085c13ee262042":"bCQlO","fd33f62ac5aa3749":"4Qjnk","662de7a1bbb4be15":"awUBr","d4066f16a566875f":"hvsRZ","b94e3c21c97ebe5d":"kbogy","8d92cce882f0a23a":"3eCpt","5f916d80b5ff18fc":"agdjk","36892a48fd4b231b":"63QOc","b6f635b9c48733e7":"hWMbR","4c9fdf8ab3c3b548":"g219r"}],"4Qjnk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var knot = function knot() {
    var extended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var events = Object.create(null);
    function on(name, handler) {
        events[name] = events[name] || [];
        events[name].push(handler);
        return this;
    }
    function once(name, handler) {
        handler._once = true;
        on(name, handler);
        return this;
    }
    function off(name) {
        var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        handler ? events[name].splice(events[name].indexOf(handler), 1) : delete events[name];
        return this;
    }
    function emit(name) {
        var _this = this;
        for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        // cache the events, to avoid consequences of mutation
        var cache = events[name] && events[name].slice();
        // only fire handlers if they exist
        cache && cache.forEach(function(handler) {
            // remove handlers added with 'once'
            handler._once && off(name, handler);
            // set 'this' context, pass args to handlers
            handler.apply(_this, args);
        });
        return this;
    }
    return _extends({}, extended, {
        on: on,
        once: once,
        off: off,
        emit: emit
    });
};
var bricks = function bricks() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // privates
    var persist = void 0; // packing new elements, or all elements?
    var ticking = void 0; // for debounced resize
    var sizeIndex = void 0;
    var sizeDetail = void 0;
    var columnTarget = void 0;
    var columnHeights = void 0;
    var nodeTop = void 0;
    var nodeLeft = void 0;
    var nodeWidth = void 0;
    var nodeHeight = void 0;
    var nodes = void 0;
    var nodesWidths = void 0;
    var nodesHeights = void 0;
    // resolve options
    var packed = options.packed.indexOf("data-") === 0 ? options.packed : "data-" + options.packed;
    var sizes = options.sizes.slice().reverse();
    var position = options.position !== false;
    var container = options.container.nodeType ? options.container : document.querySelector(options.container);
    var selectors = {
        all: function all() {
            return toArray(container.children);
        },
        new: function _new() {
            return toArray(container.children).filter(function(node) {
                return !node.hasAttribute("" + packed);
            });
        }
    };
    // series
    var setup = [
        setSizeIndex,
        setSizeDetail,
        setColumns
    ];
    var run = [
        setNodes,
        setNodesDimensions,
        setNodesStyles,
        setContainerStyles
    ];
    // instance
    var instance = knot({
        pack: pack,
        update: update,
        resize: resize
    });
    return instance;
    // general helpers
    function runSeries(functions) {
        functions.forEach(function(func) {
            return func();
        });
    }
    // array helpers
    function toArray(input) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
        return Array.prototype.slice.call(input);
    }
    function fillArray(length) {
        return Array.apply(null, Array(length)).map(function() {
            return 0;
        });
    }
    // size helpers
    function getSizeIndex() {
        // find index of widest matching media query
        return sizes.map(function(size) {
            return size.mq && window.matchMedia("(min-width: " + size.mq + ")").matches;
        }).indexOf(true);
    }
    function setSizeIndex() {
        sizeIndex = getSizeIndex();
    }
    function setSizeDetail() {
        // if no media queries matched, use the base case
        sizeDetail = sizeIndex === -1 ? sizes[sizes.length - 1] : sizes[sizeIndex];
    }
    // column helpers
    function setColumns() {
        columnHeights = fillArray(sizeDetail.columns);
    }
    // node helpers
    function setNodes() {
        nodes = selectors[persist ? "new" : "all"]();
    }
    function setNodesDimensions() {
        // exit if empty container
        if (nodes.length === 0) return;
        nodesWidths = nodes.map(function(element) {
            return element.clientWidth;
        });
        nodesHeights = nodes.map(function(element) {
            return element.clientHeight;
        });
    }
    function setNodesStyles() {
        nodes.forEach(function(element, index) {
            columnTarget = columnHeights.indexOf(Math.min.apply(Math, columnHeights));
            element.style.position = "absolute";
            nodeTop = columnHeights[columnTarget] + "px";
            nodeLeft = columnTarget * nodesWidths[index] + columnTarget * sizeDetail.gutter + "px";
            // support positioned elements (default) or transformed elements
            if (position) {
                element.style.top = nodeTop;
                element.style.left = nodeLeft;
            } else element.style.transform = "translate3d(" + nodeLeft + ", " + nodeTop + ", 0)";
            element.setAttribute(packed, "");
            // ignore nodes with no width and/or height
            nodeWidth = nodesWidths[index];
            nodeHeight = nodesHeights[index];
            if (nodeWidth && nodeHeight) columnHeights[columnTarget] += nodeHeight + sizeDetail.gutter;
        });
    }
    // container helpers
    function setContainerStyles() {
        container.style.position = "relative";
        container.style.width = sizeDetail.columns * nodeWidth + (sizeDetail.columns - 1) * sizeDetail.gutter + "px";
        container.style.height = Math.max.apply(Math, columnHeights) - sizeDetail.gutter + "px";
    }
    // resize helpers
    function resizeFrame() {
        if (!ticking) {
            window.requestAnimationFrame(resizeHandler);
            ticking = true;
        }
    }
    function resizeHandler() {
        if (sizeIndex !== getSizeIndex()) {
            pack();
            instance.emit("resize", sizeDetail);
        }
        ticking = false;
    }
    // API
    function pack() {
        persist = false;
        runSeries(setup.concat(run));
        return instance.emit("pack");
    }
    function update() {
        persist = true;
        runSeries(run);
        return instance.emit("update");
    }
    function resize() {
        var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var action = flag ? "addEventListener" : "removeEventListener";
        window[action]("resize", resizeFrame);
        return instance;
    }
};
exports.default = bricks;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agdjk":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var js_brand_1 = require("86b2e43762abeb98");
var css_1 = require("a4ba849b0c41f326");
var preact_1 = require("ebb6349c6798056b");
var fetchError = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    color: ",
    ";\n    display: flex;\n    justify-content: center;\n    margin: 30px 0;\n    font-family: ",
    ";\n    font-size: 16px;\n    font-weight: 600;\n    a {\n        color: ",
    ";\n        cursor: pointer;\n        &:hover {\n            color: white;\n        }\n    }\n"
], [
    "\n    color: ",
    ";\n    display: flex;\n    justify-content: center;\n    margin: 30px 0;\n    font-family: ",
    ";\n    font-size: 16px;\n    font-weight: 600;\n    a {\n        color: ",
    ";\n        cursor: pointer;\n        &:hover {\n            color: white;\n        }\n    }\n"
])), js_brand_1.giphyLightGrey, js_brand_1.fontFamily.body, js_brand_1.giphyBlue);
var FetchError = function(_a) {
    var onClick = _a.onClick;
    return (0, preact_1.h)("div", {
        className: fetchError
    }, "Error loading GIFs.\xa0", (0, preact_1.h)("a", {
        onClick: onClick
    }, "Try again?"));
};
exports.default = FetchError;
var templateObject_1;

},{"86b2e43762abeb98":"gyA2O","a4ba849b0c41f326":"awUBr","ebb6349c6798056b":"hvsRZ"}],"hWMbR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var js_brand_1 = require("8404bb709245d977");
var css_1 = require("a3d9248e4a3712a9");
var preact_1 = require("69c2770b389f683f");
// trying to share css from brand, but this has an element structure
// so it's ugly. will probably move the css in here
exports.default = function(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    return (0, preact_1.h)("div", {
        className: (0, css_1.cx)(js_brand_1.loader, className)
    }, (0, preact_1.h)("div", null), (0, preact_1.h)("div", null), (0, preact_1.h)("div", null), (0, preact_1.h)("div", null), (0, preact_1.h)("div", null));
};

},{"8404bb709245d977":"gyA2O","a3d9248e4a3712a9":"awUBr","69c2770b389f683f":"hvsRZ"}],"2pyP9":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var js_util_1 = require("89d2a12000d86d03");
var css_1 = require("6f57c0825c588d1d");
var preact_1 = require("a715fa5bcef04d69");
var hooks_1 = require("6e5e0184e3778f5c");
var play_pause_1 = require("d6f9c17c6f139610");
var volume_1 = require("10af60af64c28b21");
var progress_bar_1 = __importDefault(require("9cec2514070b44ec"));
var video_1 = __importDefault(require("195edadf16b1043b"));
var containerCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    position: relative;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: black;\n"
], [
    "\n    position: relative;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: black;\n"
])));
var volumeCss = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject([
    "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"
], [
    "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"
])));
var controlsCss = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject([
    "\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    left: 10px;\n    display: flex;\n    justify-content: space-between;\n    transition: opacity ease-out 250ms;\n"
], [
    "\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    left: 10px;\n    display: flex;\n    justify-content: space-between;\n    transition: opacity ease-out 250ms;\n"
])));
var VideoPlayer = function(props) {
    var width = props.width, hideMute = props.hideMute, hidePlayPause = props.hidePlayPause, hideProgressBar = props.hideProgressBar, className = props.className, persistentControls = props.persistentControls;
    var _a = (0, hooks_1.useState)(false), isHovered = _a[0], setIsHovered = _a[1];
    var _b = (0, hooks_1.useState)("paused"), playState = _b[0], setPlayState = _b[1];
    var _c = (0, hooks_1.useState)(null), videoEl = _c[0], _setVideoEl = _c[1];
    var _d = (0, hooks_1.useState)(props.muted), muted = _d[0], setMuted = _d[1];
    var _e = (0, hooks_1.useState)(false), mutedByBrowser = _e[0], setMutedByBrowser = _e[1];
    var onStateChange = props.onStateChange, setVideoEl = props.setVideoEl, onMuted = props.onMuted, onUserMuted = props.onUserMuted;
    var height = props.height || (0, js_util_1.getGifHeight)(props.gif, width);
    var combinedSetPlayState = (0, hooks_1.useCallback)(function(args) {
        onStateChange === null || onStateChange === void 0 || onStateChange(args);
        setPlayState(args);
    }, [
        onStateChange,
        setPlayState
    ]);
    var combinedOnMuted = (0, hooks_1.useCallback)(function(args) {
        onMuted === null || onMuted === void 0 || onMuted(args);
        setMutedByBrowser(args);
    }, [
        setMutedByBrowser,
        onMuted
    ]);
    var combinedSetVideoEl = (0, hooks_1.useCallback)(function(args) {
        setVideoEl === null || setVideoEl === void 0 || setVideoEl(args);
        _setVideoEl(args);
    }, [
        setVideoEl,
        _setVideoEl
    ]);
    var toggleMute = function() {
        if (mutedByBrowser) {
            setMutedByBrowser(false);
            setMuted(false);
        } else setMuted(!muted);
    };
    (0, hooks_1.useEffect)(function() {
        setMuted(props.muted);
    }, [
        props.muted
    ]);
    return (0, preact_1.h)("div", {
        className: (0, css_1.cx)(containerCss, className),
        style: {
            width: width,
            height: height
        },
        onMouseOver: function() {
            return setIsHovered(true);
        },
        onMouseLeave: function() {
            return setIsHovered(false);
        }
    }, (0, preact_1.h)(video_1.default, __assign({}, props, {
        onStateChange: combinedSetPlayState,
        onMuted: combinedOnMuted,
        setVideoEl: combinedSetVideoEl,
        muted: muted
    })), (0, preact_1.h)("div", {
        style: {
            opacity: persistentControls || isHovered ? 1 : 0
        },
        className: controlsCss
    }, videoEl && !hidePlayPause ? (0, preact_1.h)("div", {
        onClick: function() {
            if (playState === "playing") videoEl.pause();
            else videoEl.play();
        }
    }, playState === "playing" ? (0, preact_1.h)(play_pause_1.PauseIcon, null) : (0, preact_1.h)(play_pause_1.PlayIcon, null)) : (0, preact_1.h)("div", null), !hideMute && (0, preact_1.h)("div", {
        className: volumeCss,
        onClick: function(e) {
            onUserMuted === null || onUserMuted === void 0 || onUserMuted(!muted);
            e.preventDefault();
            toggleMute();
        }
    }, muted || mutedByBrowser ? (0, preact_1.h)(volume_1.VolumeOffIcon, null) : (0, preact_1.h)(volume_1.VolumeOnIcon, null))), (persistentControls || isHovered) && !hideProgressBar && videoEl ? (0, preact_1.h)(progress_bar_1.default, {
        videoEl: videoEl
    }) : null);
};
var VideoWrapper = function(props) {
    return props.controls ? (0, preact_1.h)(VideoPlayer, __assign({}, props)) : (0, preact_1.h)(video_1.default, __assign({}, props));
};
VideoWrapper.className = video_1.default.className;
exports.default = VideoWrapper;
var templateObject_1, templateObject_2, templateObject_3;

},{"89d2a12000d86d03":"lEFUV","6f57c0825c588d1d":"awUBr","a715fa5bcef04d69":"hvsRZ","6e5e0184e3778f5c":"2TRXI","d6f9c17c6f139610":"gILYw","10af60af64c28b21":"hewQt","9cec2514070b44ec":"kVzW8","195edadf16b1043b":"cKBZM"}],"gILYw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PauseIcon = exports.PlayIcon = exports.PlayPauseSize = void 0;
var preact_1 = require("7fc08dcbfd6839eb");
exports.PlayPauseSize = 25;
var PlayIcon = function(_a) {
    var _b = _a.size, size = _b === void 0 ? exports.PlayPauseSize : _b;
    return (0, preact_1.h)("svg", {
        height: size,
        viewBox: "15.39 10.84 18.21 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, preact_1.h)("g", {
        fillRule: "evenodd",
        fill: "none"
    }, (0, preact_1.h)("path", {
        fill: "#fff",
        d: "M15.836 10.842c.135 0 .27.04.404.12L33.444 22.86c.107.087.161.19.161.311 0 .12-.054.224-.161.31-11.649 7.575-17.528 11.362-17.64 11.362a.632.632 0 0 1-.41-.13l.025-23.75a.804.804 0 0 1 .417-.12z"
    })));
};
exports.PlayIcon = PlayIcon;
var PauseIcon = function(_a) {
    var _b = _a.size, size = _b === void 0 ? exports.PlayPauseSize : _b;
    return (0, preact_1.h)("svg", {
        height: size,
        viewBox: "0.92 0.92 23.54 24",
        width: size,
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, preact_1.h)("g", {
        id: "Page-1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, (0, preact_1.h)("g", {
        id: "Group",
        transform: "translate(0.916948, 0.916948)",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }, (0, preact_1.h)("path", {
        d: "M0,23.2 L0,0.8 C0,0.3581722 0.3581722,0 0.8,0 L8.2,0 C8.64182776,0 9,0.3581722 9,0.8 L9,23.2 C9,23.6418278 8.64182776,24 8.2,24 L0.8,24 C0.3581722,24 0,23.6418278 0,23.2 Z",
        id: "Path"
    }), (0, preact_1.h)("path", {
        d: "M14.5408163,23.2 L14.5408163,0.8 C14.5408163,0.3581722 14.8989886,0 15.3408163,0 L22.7408163,0 C23.1826441,0 23.5408163,0.3581722 23.5408163,0.8 L23.5408163,23.2 C23.5408163,23.6418278 23.1826441,24 22.7408163,24 L15.3408163,24 C14.8989886,24 14.5408163,23.6418278 14.5408163,23.2 Z",
        id: "Path"
    }))));
};
exports.PauseIcon = PauseIcon;

},{"7fc08dcbfd6839eb":"hvsRZ"}],"hewQt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VolumeOffIcon = exports.VolumeOnIcon = exports.VolumeSize = void 0;
var preact_1 = require("1d184617e403873c");
exports.VolumeSize = 25;
var VolumeOnIcon = function(_a) {
    var _b = _a.size, size = _b === void 0 ? exports.VolumeSize : _b, _c = _a.onClick, onClick = _c === void 0 ? function() {} : _c;
    return (0, preact_1.h)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 26 23",
        onClick: onClick
    }, (0, preact_1.h)("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, (0, preact_1.h)("g", {
        transform: "translate(1.000000, 0.000000)",
        fill: "#FFF",
        fillRule: "nonzero"
    }, (0, preact_1.h)("path", {
        d: "M11.9625091,0.572584405 L11.9625091,22.2272644 C11.9625091,22.4856644 11.8466091,22.6635044 11.6151891,22.7611644 C11.3480491,22.8413444 11.1390491,22.7968844 10.9878091,22.6277844 L4.8732291,15.9143244 L0.573909096,15.9143244 C0.413549096,15.9143244 0.277509096,15.8588444 0.166549096,15.7475044 C0.0573082348,15.6406091 -0.00292164572,15.4933347 -1.77635684e-15,15.3405244 L-1.77635684e-15,7.45058441 C-1.77635684e-15,7.29022441 0.0555890961,7.15456441 0.167309096,7.04322441 C0.278269096,6.93226441 0.414309096,6.87640441 0.573909096,6.87640441 L4.8732291,6.87640441 L10.9874291,0.172064405 C11.1390491,0.00296440549 11.3484291,-0.0414955945 11.6151891,0.0386844055 C11.8466091,0.136344405 11.9621291,0.314564405 11.9621291,0.572584405 L11.9625091,0.572584405 Z"
    }), (0, preact_1.h)("path", {
        d: "M15.7579491,16.0914044 L14.6798891,13.6594044 C15.5739159,13.2635547 16.1503537,12.3776671 16.1501091,11.3999244 C16.150386,10.4242626 15.5763999,9.53983269 14.6852091,9.14272441 L15.7697291,6.71376441 C17.6193585,7.53872062 18.810518,9.37466359 18.8101092,11.3999244 C18.8105521,13.4298903 17.6139475,15.2691931 15.7579491,16.0914044 L15.7579491,16.0914044 Z"
    }), (0, preact_1.h)("path", {
        d: "M18.3647491,20.2619044 L17.2863091,17.8299044 C19.8302925,16.7031661 21.4705725,14.1822599 21.4701091,11.3999244 C21.4701091,8.59818441 19.8167291,6.09892441 17.3022691,4.97678441 L18.3864091,2.54782441 C21.8804724,4.10607079 24.1307363,7.57414217 24.1301093,11.3999244 C24.1308375,15.2343934 21.8705556,18.7086904 18.3647491,20.2619044 Z"
    }))));
};
exports.VolumeOnIcon = VolumeOnIcon;
var VolumeOffIcon = function(_a) {
    var _b = _a.size, size = _b === void 0 ? exports.VolumeSize : _b, _c = _a.onClick, onClick = _c === void 0 ? function() {} : _c;
    return (0, preact_1.h)("svg", {
        onClick: onClick,
        height: size,
        width: size,
        viewBox: "0 0 26 23",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, preact_1.h)("g", {
        id: "Page-1",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, (0, preact_1.h)("g", {
        id: "Group",
        transform: "translate(1.000000, 0.000000)",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }, (0, preact_1.h)("path", {
        d: "M11.9625091,0.572584405 L11.9625091,22.2272644 C11.9625091,22.4856644 11.8466091,22.6635044 11.6151891,22.7611644 C11.3480491,22.8413444 11.1390491,22.7968844 10.9878091,22.6277844 L4.8732291,15.9143244 L0.573909096,15.9143244 C0.413549096,15.9143244 0.277509096,15.8588444 0.166549096,15.7475044 C0.0573082348,15.6406091 -0.00292164572,15.4933347 0,15.3405244 L0,7.45058441 C0,7.29022441 0.0555890961,7.15456441 0.167309096,7.04322441 C0.278269096,6.93226441 0.414309096,6.87640441 0.573909096,6.87640441 L4.8732291,6.87640441 L10.9874291,0.172064405 C11.1390491,0.00296440549 11.3484291,-0.0414955945 11.6151891,0.0386844055 C11.8466091,0.136344405 11.9621291,0.314564405 11.9621291,0.572584405 L11.9625091,0.572584405 Z",
        id: "Path"
    })), (0, preact_1.h)("g", {
        id: "Group",
        transform: "translate(14.887009, 6.947630)",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }, (0, preact_1.h)("path", {
        d: "M7.88199149,6.27905236 C7.94693088,6.35707599 7.94693088,6.47033309 7.88199149,6.54835671 L6.54835671,7.88199149 C6.47033309,7.94693088 6.35707599,7.94693088 6.27905236,7.88199149 L3.96534802,5.56828715 L1.65164367,7.88199149 C1.57362004,7.94693088 1.46036294,7.94693088 1.38233932,7.88199149 L0.0487045381,6.54835671 C-0.016234846,6.47033309 -0.016234846,6.35707599 0.0487045381,6.27905236 L2.36240889,3.96534802 L0.0487045381,1.65164367 C-0.016234846,1.57362004 -0.016234846,1.46036294 0.0487045381,1.38233932 L1.38233932,0.0487045381 C1.46036294,-0.016234846 1.57362004,-0.016234846 1.65164367,0.0487045381 L3.96534802,2.36240889 L6.27905236,0.0487045381 C6.35707599,-0.016234846 6.47033309,-0.016234846 6.54835671,0.0487045381 L7.88199149,1.38233932 C7.94693088,1.46036294 7.94693088,1.57362004 7.88199149,1.65164367 L5.56828715,3.96534802 L7.88199149,6.27905236 Z",
        id: "Shape"
    }))));
};
exports.VolumeOffIcon = VolumeOffIcon;

},{"1d184617e403873c":"hvsRZ"}],"kVzW8":[function(require,module,exports) {
"use strict";
var __makeTemplateObject = this && this.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var css_1 = require("39c6d9886888c519");
var js_brand_1 = require("eb2f526fc4a8cc0e");
var hooks_1 = require("d5bfe8d1d2ec466b");
var preact_1 = require("5ceda580613ad7bd");
var useRaf = function(ms, delay) {
    if (ms === void 0) ms = 1e12;
    if (delay === void 0) delay = 0;
    var _a = (0, hooks_1.useState)(0), elapsed = _a[0], set = _a[1];
    (0, hooks_1.useLayoutEffect)(function() {
        var raf;
        var timerStop;
        var start;
        var onFrame = function() {
            var time = Math.min(1, (Date.now() - start) / ms);
            set(time);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            loop();
        };
        var loop = function() {
            raf = requestAnimationFrame(onFrame);
        };
        var onStart = function() {
            timerStop = setTimeout(function() {
                cancelAnimationFrame(raf);
                set(1);
            }, ms);
            start = Date.now();
            loop();
        };
        var timerDelay = setTimeout(onStart, delay);
        return function() {
            clearTimeout(timerStop);
            clearTimeout(timerDelay);
            cancelAnimationFrame(raf);
        };
    }, [
        ms,
        delay
    ]);
    return elapsed;
};
var barCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([
    "\n    background: ",
    ";\n    height: 2px;\n    position: absolute;\n    width: 5px;\n    bottom: 0;\n    left: 0;\n    opacity: 0.95;\n"
], [
    "\n    background: ",
    ";\n    height: 2px;\n    position: absolute;\n    width: 5px;\n    bottom: 0;\n    left: 0;\n    opacity: 0.95;\n"
])), js_brand_1.giphyWhite);
var ProgressBar = function(_a) {
    var videoEl = _a.videoEl;
    var _b = (0, hooks_1.useState)(0), progress = _b[0], setProgress = _b[1];
    useRaf(2147483647, 100);
    var time = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.currentTime) || 0;
    var duration = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.duration) || 0;
    var val = time / duration;
    (0, hooks_1.useLayoutEffect)(function() {
        setProgress(val);
    }, [
        val,
        setProgress
    ]);
    var perc = Math.round(progress * 100);
    perc = duration < 10 && perc > 98 ? 100 : perc;
    return (0, preact_1.h)("div", {
        style: {
            width: "".concat(perc, "%")
        },
        className: barCss
    });
};
exports.default = ProgressBar;
var templateObject_1;

},{"39c6d9886888c519":"awUBr","eb2f526fc4a8cc0e":"gyA2O","d5bfe8d1d2ec466b":"2TRXI","5ceda580613ad7bd":"hvsRZ"}],"cKBZM":[function(require,module,exports) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var js_analytics_1 = require("15ef1e14e5768d71");
var js_util_1 = require("988d1d198cca4820");
var preact_1 = require("31e6c0022cb6df2a");
var hooks_1 = require("3609ff0cf96c198");
var util_1 = require("9b20b6a361f5b0cb");
var quartileEvents = [
    0.25,
    0.5,
    0.75
];
var Network = {
    // The element has not yet been initialized. All attributes are in their initial states.
    EMPTY: 0,
    // The element's resource selection algorithm is active and has selected a resource, but it is not actually using the network at this time.
    IDLE: 1,
    // The user agent is actively trying to download data.
    LOADING: 2,
    // The element's resource selection algorithm is active, but it has not yet found a resource to use.
    NO_SOURCE: 3
};
var Video = function(_a) {
    var muted = _a.muted, _b = _a.loop, loop = _b === void 0 ? true : _b, onStateChange = _a.onStateChange, onTimeUpdate = _a.onTimeUpdate, onCanPlay = _a.onCanPlay, onFirstPlay = _a.onFirstPlay, onWaiting = _a.onWaiting, onMuted = _a.onMuted, onError = _a.onError, onEnded = _a.onEnded, onLoop = _a.onLoop, onQuartile = _a.onQuartile, onEndFullscreen = _a.onEndFullscreen, setVideoEl = _a.setVideoEl, gif = _a.gif, width = _a.width, height_ = _a.height, _c = _a.volume, volume = _c === void 0 ? 0.7 : _c, className = _a.className;
    var height = height_ || (0, js_util_1.getGifHeight)(gif, width);
    // state
    var _d = (0, hooks_1.useState)((0, js_util_1.getBestVideo)(gif.video, width, height)), media = _d[0], setMedia = _d[1];
    var seek = (0, hooks_1.useRef)(0);
    if (!media) // Not all gif requests have video content
    // use { type: 'videos' } for search or trending endpoints
    console.warn("GiphyJS No video content for id: ".concat(gif.id));
    var mountTime = (0, hooks_1.useRef)(Date.now());
    var hasPlayingFired = (0, hooks_1.useRef)(false);
    var loopNumber = (0, hooks_1.useRef)(0);
    var waitingCount = (0, hooks_1.useRef)(0);
    var quartilesFired = (0, hooks_1.useRef)(new Set());
    // reset the above when the gif.id changes
    (0, hooks_1.useEffect)(function() {
        mountTime.current = Date.now();
        hasPlayingFired.current = false;
        loopNumber.current = 1;
        waitingCount.current = 0;
        quartilesFired.current = new Set();
    }, [
        gif.id
    ]);
    var videoEl = (0, hooks_1.useRef)(null);
    (0, hooks_1.useEffect)(function() {
        // when the width and height change, check if there's a new url
        var newMedia = (0, js_util_1.getBestVideo)(gif.video, width, height);
        if (videoEl.current && (media === null || media === void 0 ? void 0 : media.url) && newMedia.url !== media.url) {
            // we may have changed gifs, we don't want to seek then
            if (media.url.indexOf(String(gif.id)) !== -1) // when the media changes set the current seek time
            seek.current = videoEl.current.currentTime;
            // triggers re-render with above seek time
            setMedia(newMedia);
        }
    }, [
        width,
        height_,
        gif.video,
        height,
        media === null || media === void 0 ? void 0 : media.url,
        gif.id
    ]);
    (0, hooks_1.useEffect)(function() {
        if (videoEl.current && (media === null || media === void 0 ? void 0 : media.url) && seek.current) {
            videoEl.current.currentTime = seek.current;
            seek.current = 0;
        }
    }, [
        media === null || media === void 0 ? void 0 : media.url,
        seek
    ]);
    var _onError = (0, hooks_1.useCallback)(function() {
        var _a;
        var el = videoEl.current;
        var code = (_a = el === null || el === void 0 ? void 0 : el.error) === null || _a === void 0 ? void 0 : _a.code;
        if (code && (el === null || el === void 0 ? void 0 : el.src)) {
            var message = (0, util_1.getErrorMessage)(code, el === null || el === void 0 ? void 0 : el.src);
            console.error(message);
            onError === null || onError === void 0 || onError(code);
        }
    }, [
        onError
    ]);
    var _onPlaying = (0, hooks_1.useCallback)(function() {
        onStateChange === null || onStateChange === void 0 || onStateChange("playing");
        if (!hasPlayingFired.current) {
            hasPlayingFired.current = true;
            if (gif.analytics_response_payload) (0, js_analytics_1.pingback)({
                actionType: "START",
                analyticsResponsePayload: gif.analytics_response_payload
            });
            onFirstPlay === null || onFirstPlay === void 0 || onFirstPlay(Date.now() - mountTime.current);
        }
    }, [
        onFirstPlay,
        onStateChange
    ]);
    var _onPaused = (0, hooks_1.useCallback)(function() {
        return onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange("paused");
    }, [
        onStateChange
    ]);
    var _onTimeUpdate = (0, hooks_1.useCallback)(function() {
        var el = videoEl.current;
        if (el) {
            var playhead_1 = el.currentTime;
            quartileEvents.some(function(q) {
                if ((0, util_1.shouldFireQuartile)(q, playhead_1, el.duration, quartilesFired.current, loopNumber.current)) {
                    onQuartile === null || onQuartile === void 0 || onQuartile(q);
                    return true;
                }
                return false;
            });
            onTimeUpdate === null || onTimeUpdate === void 0 || onTimeUpdate(playhead_1 || 0);
        }
    }, [
        onQuartile,
        onTimeUpdate
    ]);
    var _onCanPlay = (0, hooks_1.useCallback)(function() {
        return onCanPlay === null || onCanPlay === void 0 ? void 0 : onCanPlay();
    }, [
        onCanPlay
    ]);
    var _onWaiting = (0, hooks_1.useCallback)(function() {
        var el = videoEl.current;
        // we get a waiting event after a loop, so ignore the first one while the play head is 0
        if ((el === null || el === void 0 ? void 0 : el.currentTime) !== 0 && (el === null || el === void 0 ? void 0 : el.networkState) !== Network.IDLE) onWaiting === null || onWaiting === void 0 || onWaiting(++waitingCount.current);
    }, [
        onWaiting
    ]);
    var _onEnded = (0, hooks_1.useCallback)(function() {
        // helps prevent two ended events when changing media
        if (!hasPlayingFired.current) return;
        if (loop && videoEl.current) videoEl.current.play();
        onLoop === null || onLoop === void 0 || onLoop(loopNumber.current);
        loopNumber.current = loopNumber.current + 1;
        onEnded === null || onEnded === void 0 || onEnded();
    }, [
        onEnded,
        loop,
        onLoop
    ]);
    var _onEndFullscreen = (0, hooks_1.useCallback)(function() {
        return onEndFullscreen === null || onEndFullscreen === void 0 ? void 0 : onEndFullscreen();
    }, [
        onEndFullscreen
    ]);
    var tryAutoPlayWithSound = (0, hooks_1.useCallback)(function(videoEl) {
        return __awaiter(void 0, void 0, void 0, function() {
            var promisePlay, error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!videoEl) return [
                            3 /*break*/ ,
                            4
                        ];
                        promisePlay = videoEl.play();
                        if (!(promisePlay !== undefined)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            promisePlay
                        ];
                    case 2:
                        _a.sent();
                        onMuted === null || onMuted === void 0 || onMuted(false);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        // Autoplay not allowed!
                        // Mute video and try to play again
                        videoEl.muted = true;
                        // Allow the UI to show that the video is muted
                        onMuted === null || onMuted === void 0 || onMuted(true);
                        videoEl.play();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        onMuted
    ]);
    (0, hooks_1.useEffect)(function() {
        var el = videoEl.current;
        if (el) {
            tryAutoPlayWithSound(el);
            setVideoEl === null || setVideoEl === void 0 || setVideoEl(el);
            if (!isNaN(volume)) el.volume = volume;
        }
    }, []);
    (0, hooks_1.useEffect)(function() {
        var el = videoEl.current;
        if (el) {
            el.addEventListener("play", _onPlaying);
            el.addEventListener("pause", _onPaused);
            el.addEventListener("error", _onError);
            el.addEventListener("timeupdate", _onTimeUpdate);
            el.addEventListener("canplay", _onCanPlay);
            el.addEventListener("ended", _onEnded);
            el.addEventListener("waiting", _onWaiting);
            el.addEventListener("webkitendfullscreen", _onEndFullscreen); // this is needed for iOS
        }
        return function() {
            if (el) {
                el.removeEventListener("play", _onPlaying);
                el.removeEventListener("pause", _onPaused);
                el.removeEventListener("error", _onError);
                el.removeEventListener("timeupdate", _onTimeUpdate);
                el.removeEventListener("canplay", _onCanPlay);
                el.removeEventListener("ended", _onEnded);
                el.removeEventListener("waiting", _onWaiting);
                el.removeEventListener("webkitendfullscreen", _onEndFullscreen);
            }
        };
    }, [
        _onPlaying,
        _onPaused,
        _onError,
        _onTimeUpdate,
        _onCanPlay,
        _onEnded,
        _onWaiting,
        _onEndFullscreen
    ]);
    return (media === null || media === void 0 ? void 0 : media.url) ? (0, preact_1.h)("video", {
        className: className,
        width: width,
        height: height,
        muted: muted,
        autoPlay: true,
        playsInline: true,
        ref: videoEl,
        src: media === null || media === void 0 ? void 0 : media.url
    }) : null;
};
Video.className = "giphy-video";
exports.default = Video;

},{"15ef1e14e5768d71":"hBsEL","988d1d198cca4820":"lEFUV","31e6c0022cb6df2a":"hvsRZ","3609ff0cf96c198":"2TRXI","9b20b6a361f5b0cb":"hx8aJ"}],"hx8aJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldFireQuartile = exports.getErrorMessage = void 0;
var getErrorMessage = function(code, src) {
    if (src === void 0) src = "";
    switch(code){
        case 1:
            return "Aborted. The fetching process for the media resource was aborted by the user agent at the user's request.";
        case 2:
            return "Network Error. A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable.";
        case 3:
            return "Decode Error. An error of some description occurred while decoding the media resource, after the resource was established to be usable.";
        case 4:
            return 'Can not play a video of type "'.concat(src.split(".").pop(), '" on this platform.');
        default:
            return "";
    }
};
exports.getErrorMessage = getErrorMessage;
var shouldFireQuartile = function(quartile, playhead, duration, quartilesFired, loopNumber) {
    var currentQuartile = loopNumber + quartile;
    // NOTE: Should only fire on first loop, if looping.
    if (!quartilesFired.has(currentQuartile) && duration > 0 && playhead > duration * quartile) {
        quartilesFired.add(currentQuartile);
        return true;
    }
    return false;
};
exports.shouldFireQuartile = shouldFireQuartile;

},{}],"fvbVk":[function(require,module,exports) {
module.exports = JSON.parse('{"scripts":{"clean":"rm -rf ./dist","types":"tsc ./src/index.tsx -d --emitDeclarationOnly -declarationDir ./dist","dev":"parcel public/test.html","build":"tsc","prepublish":"npm run clean && tsc"},"devDependencies":{"@types/bricks.js":"^1.8.1","@types/throttle-debounce":"^2.1.0","parcel-bundler":"latest","typescript":"^4.7.4"},"name":"@giphy/js-components","version":"5.12.1","description":"A lightweight set of components, focused on easy-of-use and performance.","homepage":"https://github.com/Giphy/giphy-js/tree/master/packages/components","main":"dist/index.js","types":"dist/index.d.ts","files":["dist/**/*","src/**/*"],"author":"giannif","license":"MIT","publishConfig":{"access":"public"},"dependencies":{"@emotion/css":"11.9.0","@giphy/js-analytics":"*","@giphy/js-brand":"*","@giphy/js-fetch-api":"*","@giphy/js-types":"*","@giphy/js-util":"*","bricks.js":"^1.8.0","intersection-observer":"^0.11.0","preact":"10.4.8","throttle-debounce":"^3.0.1"}}');

},{}]},["1gxIg"], "1gxIg", "parcelRequire460e")

//# sourceMappingURL=chat.af53ec5a.js.map
